import { v4 as uuidv4 } from 'uuid';
import {  addMultipleRowsHelper,applyTransaction, findGroupByGroupId, getLargestSelectedIndex, getSelectedRowIndexes, getSmallestSelectedIndex, indexIsInCellRange, makeColStateObj, makeFirstColumnAlwaysVisibleUnderAGroup, removeAColumnFromColumnDefs, removeLinkedColumns, syncColumnDefsWithColState, unGroupColumn,  validatel_id, getUniqueChildrenArray, expandAboveNode, collapseAboveNode, HighlightBasedOnTimeRange, deleteColumnGroup, sanitizeColumnDefs, getTemplateColumnContext, columnInstanceThatCannotBeDeleted } from './helperFunctions';
import CustomCellRenderer from '../components/Grid/CustomCellRenderer';
import { CustomCellEditor } from '../components/Grid/CustomCellEditor';
import { CustomTextNumberFilter } from '../cellComponents/Filters/CustomTextNumberFilter';
import { addColumnToGroup, addGroupParent,deepCopy,findColumnByTypeOrField,findDragToIndexForGroupColumn,getAllParentsOfANode,getFlatChildrenColumnOfTimeSeries,getIndexesFromNodeArray, parentRowsAferRollup, recursivelyCalculateParent, removePredecessorAndSuccessorNodes, removeThisNodeAsPredecessorFromOtherRows, removeThisNodeAsSuccessorFromOtherRows } from './helpersSubModule';
import { TimeSeriesColumngroup } from '../components/Grid/gridHelperFunctions';
import { reGroupTimeSeries } from './dataHarvestHelperTypeScript';
import { SetTotalTimeSeriesColumnProperties } from './helperFunctions';
import { categorizeAndStoreUpdatedRows } from '../redux/action/gridAction';
import xTablesStore from "../redux/xTablesStore";
import { updateTotalIfValueIsChanged } from './xTablesHelper';
import { handleRowDragOperation } from '../Undo/operations/DragOperation';
import { insertMultipleRowsCore } from '../Undo/operations/InsertOperation';
import { prepareRowDeletion } from '../Undo/operations/DeleteOperation';
import { context, trace } from '@opentelemetry/api';
import { logSpan } from '../../../helpers/loggingHelper';
import { formatDeleteUndoInfo, formatInsertUndoInfoForLogs } from '../../../helpers/loggerFormatHelper';
import { renderAlert } from '../../../CommonComponents/Alert/Alert';
import { scheduleGridToCardSync } from '../redux/thunks/cardViewThunks';


const tracer = trace.getTracer('callback-helper')

export const getOutdentedValue = (value) => {
    let values = value.split('.');
    let outdentedValue = '';
    for (let i = 0; i < values.length - 2; i++) {
        outdentedValue += values[i] + ".";
    }
    outdentedValue = outdentedValue + values[values.length - 1];
    return outdentedValue;
}

export const findMaxColNum = (newColDefs) => {
    const extractColNums = (colDefs) => {
        const colNums = colDefs?.map(colDef => {
            if(colDef.field){
                let fieldVal = colDef.block==='timeseries'?colDef.colId: colDef['field'];
                if ( fieldVal !== undefined && fieldVal !== '#' ) {
                    if(fieldVal.includes("Column")){
                        let numStr = fieldVal.substring(6);
                        let num = parseInt(numStr, 10);
                        if (!Number.isNaN(num)) {
                            return num;
                          }
                    }
                    
                }
            }
            else return 0;
        });

        let nestedColNums = colDefs
            ?.filter(colDef => colDef.children)
            ?.flatMap(colDef => extractColNums(colDef.children));

        return [...colNums, ...nestedColNums];
    };
    let colNums = extractColNums(newColDefs);
    let temp = colNums.filter(value => typeof value === 'number');
    if (temp.length) {
        const maxNum = Math.max(...temp);
        return maxNum;
    } else {
        return 0;
    }
};

export const findAvailableSlotsForColumnNumbering = (columns, n) => {
    // Helper function to extract numbers from column fields
    const extractNumbers = (colDefs) => {
        const numbers = colDefs?.map(colDef => {
            if (colDef.field) {
                let fieldVal = colDef.block === 'timeseries' ? colDef.colId : colDef.field;
                if (fieldVal !== undefined && fieldVal.startsWith('Column')) {
                    let numStr = fieldVal.substring(6);
                    let num = parseInt(numStr, 10);
                    if (!isNaN(num)) return num;
                }
            }
            return null;
        }).filter(num => num !== null);

        let nestedNumbers = colDefs
            .filter(colDef => colDef.children)
            .flatMap(colDef => extractNumbers(colDef.children));

        return [...numbers, ...nestedNumbers];
    };

    const colNums = extractNumbers(columns);
    const existingNumbers = new Set(colNums);
    let availableSlots = [];

    let currentNumber = 1;
    while (availableSlots.length < n) {
        if (!existingNumbers.has(currentNumber)) {
            availableSlots.push(currentNumber);
        }
        currentNumber++;
    }
    return availableSlots;
};
export const insertColumnsLeft = ({ gridRef, undoStack, dispatch, selectedSheetId, columnMenuParams, setColumnDefs, addColumnToIndex,setInsertColumn,openModalContainer ,allColumns,clickSave}) => {
    const undoStackData = undoStack && undoStack.length ? undoStack : [];
    let selectedFirstColumnIndex, selectedColumnCount, isPrimaryColumn;
    const newColDefsRaw = gridRef.current.props.columnDefs.slice();
    const autoGroupColumnDefRaw = gridRef.current.api.getColumnDef("ag-Grid-AutoColumn");
    let colStateObj = makeColStateObj(gridRef.current.api.getColumnState())
    let { newColDefs, autoGroupColumnDef } = syncColumnDefsWithColState({ colDefs: newColDefsRaw, autoColumnGroupDef: autoGroupColumnDefRaw, colState: colStateObj })
    gridRef.current.api.clearFocusedCell();
    const maxNum = findMaxColNum(allColumns)
    if(clickSave) clickSave();
    let columnToInsert = {
        "columnElasticid": uuidv4() + '_es', field: `Column${maxNum + 1}`, headerName: `Column ${maxNum + 1}`, colId: `Column ${maxNum + 1}`, width: 300, minWidth: 50, "columnType": "local", resizable: true, editable: true, deleteable: true, cellEditor: CustomCellEditor, cellEditorPopup: true, cellRenderer: CustomCellRenderer, filter: CustomTextNumberFilter,
        cellClass: (params) => {
            if (params.data) {
                if (params.data[params.colDef.field + "_es"]) {
                    return "global-style" + params.data[params.colDef.field + "_es"].format
                }
                else return "global-style"
            }
            else return "global-style"
        },
        cellStyle: (params) => {
            let styles = {}
            if (params.data) {
                let cellInfo = { ...params.data[params.colDef.field + "_es"] }
                if (cellInfo && cellInfo.cellStyle && typeof cellInfo.cellStyle === 'object') {
                    styles = cellInfo.cellStyle 
                }
                let {color} = xTablesStore.getState().gridReducer

                if(cellInfo.updatedDate && HighlightBasedOnTimeRange(cellInfo.updatedDate)) styles={...styles,backgroundColor:color}
                return styles
            }
            return styles
        }
    }
    
    if (columnMenuParams?.column?.parent && columnMenuParams?.column?.colDef?.parent && !columnMenuParams.column.colDef.block) {
        gridRef.current.api.setGridOption('maintainColumnOrder',false)
        let parentCol, parentColIndex
        for (let i = 0; i < newColDefs.length; i++) {
            if (columnMenuParams.column.colDef.parent === newColDefs[i].colId) { parentCol = newColDefs[i]; parentColIndex = i; break; }
        }
        columnToInsert = addGroupParent(columnToInsert, parentCol.colId)
        columnToInsert.columnGroupShow = 'open'
        let { parentColumn } = addColumnToGroup(parentCol, columnToInsert, columnMenuParams.column, "left")
        
        if (parentColumn) {
            const handleAddColumn = async(colDef,callback) => {
                const updatedColumnDefs = [colDef[0], autoGroupColumnDef, ...colDef.slice(1)]
                let columnUpdated = false;
             
             await addColumnToIndex(newColDefs.length, [columnToInsert], '', updatedColumnDefs, (success) => {
                    if (success){
                        setColumnDefs({ colDefs: colDef, 'reset':true });
                        columnUpdated=true;    
                        gridRef?.current?.api?.setColumnGroupOpened(parentColumn.groupId,true);   
                    }
                    callback(columnUpdated)
                })
            };
            openModalContainer({
                ...columnMenuParams.column,
                colId: columnToInsert.colId,
                colDef: columnToInsert,
                parent: columnMenuParams.column,
                colIndex: parentColIndex,
                insertPosition: "left",
                onAddColumn: handleAddColumn  // Pass the handler to the modal
            });
        }
    }
    else {
        gridRef.current.api.setGridOption('maintainColumnOrder',false) // for pinning primary Column
        for (let i = 0; i < newColDefs.length; i++) {
            if (columnMenuParams.column.colId === newColDefs[i].colId) { selectedFirstColumnIndex = i; break; }
            if(columnMenuParams?.column?.colDef?.block && columnMenuParams?.column?.colDef?.parent === newColDefs[i].colId) { selectedFirstColumnIndex = i; break; }
        }
        isPrimaryColumn = columnMenuParams.column.colId === 'ag-Grid-AutoColumn'
        selectedColumnCount = 1
        // find the max value of column number

        for (let i = 0; i < selectedColumnCount; i++) {
            if (!isPrimaryColumn) newColDefs.splice(selectedFirstColumnIndex, 0, { ...columnToInsert, cellRenderer: CustomCellRenderer });
        }
        let undoActivity = { "undoAction": 'delete', "redoAction": "insert", 'type': 'column', "index": selectedFirstColumnIndex, "data": columnToInsert }
        const handleAddColumn = async (colDef, callback) => {
            const updatedColumnDefs = [colDef[0], autoGroupColumnDef, ...colDef.slice(1)]
            let columnUpdated = false;
          
            addColumnToIndex(selectedFirstColumnIndex, [columnToInsert], '', updatedColumnDefs, (success) => {
                if (success) {
                    setColumnDefs({ colDefs: colDef, 'reset': true });
                    columnUpdated = true;
                    setTimeout(() => {
                        gridRef?.current?.api?.setFocusedCell(0, columnToInsert.field);
                        gridRef?.current?.api?.ensureColumnVisible(columnToInsert.colId);
                    }, 500);
                }
                callback(columnUpdated)
            });
        };
        openModalContainer({
            ...columnMenuParams.column,
            colId: columnToInsert.colId,
            colDef: columnToInsert,
            colIndex: selectedFirstColumnIndex,
            onAddColumn: handleAddColumn  // Pass the handler to the modal
        });
    }


    setTimeout(() => {
        gridRef?.current?.api?.ensureColumnVisible(columnToInsert?.colId);
    }, 1000)
}
export const insertColumnsRight = ({ gridRef, undoStack, columnMenuParams, setColumnDefs, addColumnToIndex,openModalContainer,allColumns,clickSave  }) => {
    let selectedLastColumnIndex, selectedColumnCount, isPrimaryColumn;
    let newColDefsRaw = gridRef.current.props.columnDefs.slice();
    let autoGroupColumnDefRaw = gridRef.current.api.getColumnDef("ag-Grid-AutoColumn");
    let colStateObj = makeColStateObj(gridRef.current.api.getColumnState())
    let { newColDefs, autoGroupColumnDef } = syncColumnDefsWithColState({ colDefs: newColDefsRaw, autoColumnGroupDef: autoGroupColumnDefRaw, colState: colStateObj })
    gridRef.current.api.clearFocusedCell();
    // find the max value of column number
    const maxNum = findMaxColNum(allColumns)
    if(clickSave) clickSave()
    let columnToInsert = {
        "columnElasticid": uuidv4() + "_es", field: `Column${maxNum + 1}`, headerName: `Column ${maxNum + 1}`, colId: `Column ${maxNum + 1}`, width: 300, minWidth: 50, "columnType": "local", resizable: true, editable: true, deleteable: true, cellEditor: CustomCellEditor, cellEditorPopup: true, cellRenderer: CustomCellRenderer, filter: CustomTextNumberFilter,
        cellClass: (params) => {
            if (params.data) {
                if (params.data[params.colDef.field + "_es"]) {
                    return "global-style" + params.data[params.colDef.field + "_es"].format
                }
                else return "global-style"
            }
            else return "global-style"
        },
        cellStyle: (params) => {
            let styles = {}
            if (params.data) {
                let cellInfo = { ...params.data[params.colDef.field + "_es"] }
                if (cellInfo && cellInfo.cellStyle && typeof cellInfo.cellStyle === 'object') {
                    styles = cellInfo.cellStyle 
                }
                let {color} = xTablesStore.getState().gridReducer
                if(cellInfo.updatedDate && HighlightBasedOnTimeRange(cellInfo.updatedDate)) styles={...styles,backgroundColor:color}
                return styles
            }
            return styles
        }
    }
    
    if (columnMenuParams?.column?.parent && columnMenuParams?.column?.colDef?.parent && !columnMenuParams.column.colDef.block) {
        gridRef.current.api.setGridOption('maintainColumnOrder',false) // for pinning primary Column
        let parentCol, parentColIndex
        for (let i = 0; i < newColDefs.length; i++) {
            if (columnMenuParams.column.colDef.parent === newColDefs[i].colId) { parentCol = newColDefs[i]; parentColIndex = i; break; }
        }
        columnToInsert = addGroupParent(columnToInsert, parentCol.colId)
        columnToInsert.columnGroupShow = 'open'
        let { parentColumn } = addColumnToGroup(parentCol, columnToInsert, columnMenuParams.column, "right")
        
        if (parentColumn) {

            const handleAddColumn = async(colDef) => {
                //colDef.splice(parentColIndex,1,parentColumn)
                let columnUpdated = false;
                const updatedColumnDefs = [colDef[0], autoGroupColumnDef, ...colDef.slice(1)]
               
               await  addColumnToIndex(newColDefs.length, [columnToInsert], '', updatedColumnDefs, (success) => {
                    if (success){
                        setColumnDefs({ colDefs: colDef,'reset':true  });
                        columnUpdated=true; 
                        gridRef?.current?.api?.setColumnGroupOpened(parentColumn.groupId,true);     
                        gridRef?.current?.api?.setFocusedCell(0, columnToInsert.colId);   
                    }

                })
                return columnUpdated;
            };
            openModalContainer({
                ...columnMenuParams.column,
                colId: columnToInsert.colId,
                colDef: columnToInsert,
                parent: columnMenuParams.column,
                colIndex: parentColIndex,
                insertPosition: "right",
                onAddColumn: handleAddColumn  // Pass the handler to the modal
            });
        }
    }
    else {
        gridRef.current.api.setGridOption('maintainColumnOrder',false) // for pinning primary Column
        for (let i = 0; i < newColDefs.length; i++) {
            if (columnMenuParams.column.colId === newColDefs[i].colId) { selectedLastColumnIndex = i + 1; break; }
            if(columnMenuParams?.column?.colDef?.block && columnMenuParams?.column?.colDef?.parent === newColDefs[i].colId) { selectedLastColumnIndex = i + 1; break; }
        }
        isPrimaryColumn = columnMenuParams.column.colId === 'ag-Grid-AutoColumn'
        if (isPrimaryColumn) selectedLastColumnIndex = 0
        selectedColumnCount = 1

        for (let i = 0; i < selectedColumnCount; i++) {
            newColDefs.splice(selectedLastColumnIndex, 0, { ...columnToInsert, cellRenderer: CustomCellRenderer });
        }
        let undoActivity = { "undoAction": 'delete', "redoAction": "insert", 'type': 'column', "index": selectedLastColumnIndex, "data": columnToInsert }
        const updatedColumnDefs = [newColDefs[0], autoGroupColumnDef, ...newColDefs.slice(1)]

        const handleAddColumn =async (colDef) => {
            const updatedColumnDefs = [colDef[0], autoGroupColumnDef, ...colDef.slice(1)]
            let columnUpdated = false;
           
           await addColumnToIndex(selectedLastColumnIndex, [columnToInsert], '', updatedColumnDefs, (success) => {
                
                if (success){
                setColumnDefs({ colDefs: colDef,'reset':true  });
                columnUpdated=true;       
                setTimeout(() => {
                    gridRef?.current?.api?.setFocusedCell(0, columnToInsert.field);
                    gridRef?.current?.api?.ensureColumnVisible(columnToInsert.colId);
                }, 500);          
               
            }
            });
            return columnUpdated;
        };
        openModalContainer({
            ...columnMenuParams.column,
            colId: columnToInsert.colId,
            colDef: columnToInsert,
            colIndex: selectedLastColumnIndex,
            onAddColumn: handleAddColumn  // Pass the handler to the modal
        });
    }

    setTimeout(() => {
        gridRef?.current?.api?.ensureColumnVisible(columnToInsert?.colId);
    }, 1000)
}

export const ExtendTimeSeries = (
    setColumnDefs,
    props,
    timeSeriesConfiguration,
    colDef,
    addColumnToIndex,
    valueChangedByValueGetter,
    allColumns,
    updateColumnWithId,
    updateSheetColumns,
    extensionDirection,
    clickSave
) => {
    let prevCol
    // Normalize to array if a single object is passed
    if (!Array.isArray(colDef) && typeof colDef === 'object') {
        prevCol = deepCopy(sanitizeColumnDefs([colDef]));
        prevCol = prevCol[0];
    } else {
        prevCol = deepCopy(sanitizeColumnDefs(colDef));
    }
    let columnToUpdate = colDef;
    let existingChildrens = getFlatChildrenColumnOfTimeSeries(columnToUpdate.children);
    const autoGroupColumnDefRaw =
        props.gridRef.current.api.getColumnDef("ag-Grid-AutoColumn");
    let columnDefsRaw = props.gridRef.current.api.getColumnDefs().slice();
    let extendedDate = true
    if (extendedDate) {
        let colDefObject = JSON.parse(colDef.block);
        // Check if the `colDefObject` is of type "timeseries"
        if (colDefObject) {
            // Update `timeSeriesConfiguration` with `startDate` and `endDate` from `colDefObject`
            if (extensionDirection === "right") {
                timeSeriesConfiguration.startDate = colDefObject.startDate;
            }
            if (extensionDirection === "left")
                timeSeriesConfiguration.endDate = colDefObject.endDate;

                if (extensionDirection === "both"){
              //  timeSeriesConfiguration.endDate = colDefObject.endDate;
               //timeSeriesConfiguration.startDate = colDefObject.startDate;
            }
        }
    }
    let group = TimeSeriesColumngroup(timeSeriesConfiguration, columnDefsRaw, valueChangedByValueGetter, allColumns, extendedDate, prevCol, extensionDirection);
    columnToUpdate.block = JSON.stringify(timeSeriesConfiguration)
    let totalColumn
    if (group.children.length > 0) {
        totalColumn = group.children.shift();
    }
    // Update the parent key for each remaining object in the group array
    group?.children?.forEach((child) => {
        child.parent = colDef.colId;
    });

    const dateRegex = /\d{2}-\d{2}-\d{4}/;

    const leftChildren = [];
    const rightChildren = [];

    const existingDates = existingChildrens
        .filter(child => dateRegex.test(child.field))
        .map(child => {
            const [mm, dd, yyyy] = child.field.split("-");
            return new Date(yyyy, mm - 1, dd);
        });

    const earliestExistingDate = existingDates.length ? new Date(Math.min(...existingDates)) : null;
    const latestExistingDate = existingDates.length ? new Date(Math.max(...existingDates)) : null;

    group.children.forEach(child => {
        if (!dateRegex.test(child.field)) return;

        const [mm, dd, yyyy] = child.field.split("-");
        const childDate = new Date(yyyy, mm - 1, dd);

        if (earliestExistingDate && childDate < earliestExistingDate) {
            leftChildren.push(child);
        } else if (latestExistingDate && childDate > latestExistingDate) {
            rightChildren.push(child);
        }
    });

    columnToUpdate.children = [
        ...leftChildren,
        ...existingChildrens,
        ...rightChildren
    ];

    let colIndex = columnDefsRaw.findIndex(
        (column) => column.colId === colDef.colId
    );

    delete columnToUpdate.headerGroupComponentParams;
    delete columnToUpdate.headerGroupComponent;
    // Update the existing column definition with the new children
    if (colIndex !== -1) {
        columnToUpdate = reGroupTimeSeries(columnToUpdate)
        columnDefsRaw[colIndex] = columnToUpdate;
        props.gridRef.current.api.setGridOption('maintainColumnOrder', false)
        const updatedColDefs = [...props.gridRef.current.api.getColumnDefs()];
        updatedColDefs[colIndex] = {};
        const columnDefObj = convertArrayToObject(columnDefsRaw);
        const extractedTotalColumn = getTotalColumn(columnDefsRaw);
        setColumnDefs({ colDefs: updatedColDefs });
        setTimeout(() => {
            setColumnDefs({ colDefs: columnDefsRaw, reset: true })
        },
            500);
        if(extractedTotalColumn) SetTotalTimeSeriesColumnProperties(extractedTotalColumn, columnDefObj)
    } else {
        console.error(`Column with colId ${colDef.colId} not found`);
    }

    let updatedColumnDefsForOuterLayer = [
        autoGroupColumnDefRaw,
        ...columnDefsRaw
    ];
    clickSave()
    setTimeout(() => {
        updateColumnWithId(columnToUpdate, columnDefsRaw)  
    }, 100);
    if (updateSheetColumns) updateSheetColumns(columnDefsRaw)
    addColumnToIndex(-1, group.children, "", updatedColumnDefsForOuterLayer);
};

const getTotalColumn = (array) => {
    for (const item of array) {
        if (item.headerName === 'TimeSeries' && Array.isArray(item.children)) {
            return item.children.find(child => child.headerName === 'Total') || null;
        }
    }
    return null;
};

const convertArrayToObject = (array) =>
    array.reduce((acc, item) => {
        if (item.colId) acc[item.colId] = item;
        return acc;
    }, {});
  

export const insertTimeSeriesBlocks=(timeSeriesConfiguration,gridRef, setColumnDefs, addColumnToIndex,selectedColumn,valueChangedByValueGetter,allColumns,updateSheetColumns,setUndoStack, dispatch, deleteColumnsAPIFunction,  updateColumnWithId,clickSave )=>{
    let columnDefsRaw = gridRef.current.api.getColumnDefs().slice();
    const hasTimeSeriesInSheet = columnDefsRaw.some(obj => obj.block && (obj.parent || obj.children));
    if (hasTimeSeriesInSheet) { 
        setColumnDefs({ colDefs: columnDefsRaw});
          return;
    }
    if(clickSave) clickSave()
    gridRef.current.api.setGridOption('maintainColumnOrder',false) // for pinning primary Column
    let group=TimeSeriesColumngroup(timeSeriesConfiguration,columnDefsRaw,valueChangedByValueGetter,allColumns)
    let columnsReGrouped = reGroupTimeSeries(deepCopy(group))
    const autoGroupColumnDefRaw = gridRef.current.api.getColumnDef("ag-Grid-AutoColumn");
    let selectedColId=selectedColumn.colId
    if(selectedColumn?.colDef?.parent) selectedColId=selectedColumn?.colDef?.parent?.groupId || selectedColumn?.parent?.groupId
    let {colIndex}=removeAColumnFromColumnDefs(columnDefsRaw,selectedColId)
    columnDefsRaw.splice(colIndex+1,0,columnsReGrouped)    
    let groupWithoutChildren=JSON.parse(JSON.stringify(group))
    delete groupWithoutChildren.children
    let columnsToInsert=[group,...group.children]
    let updatedColumnDefsForOuterLayer=[columnDefsRaw[0],autoGroupColumnDefRaw,...columnDefsRaw.slice(1)]
    let insertIndex = colIndex ? colIndex + 3 : 2;
   
    setTimeout(() => {
        addColumnToIndex(insertIndex, columnsToInsert, '', updatedColumnDefsForOuterLayer, () => {
            setColumnDefs({ colDefs: columnDefsRaw });
            if (updateSheetColumns) updateSheetColumns(columnDefsRaw)
            setTimeout(() => {
                gridRef.current?.api.setColumnGroupOpened(group, true);
            }, 500)
        })
    }, 200);
     

}

export const addMutipleColumnsToRight = async ({ gridRef, columnIndex, noOfColumns, setColumnDefs, addColumnToIndex, callback }) => {
    let selectedColumnCount, currentColumnIndex = columnIndex;
    let newColDefsRaw = gridRef.current.props.columnDefs.slice();
    let autoGroupColumnDefRaw = gridRef.current.api.getColumnDef("ag-Grid-AutoColumn");
    let colStateObj = makeColStateObj(gridRef.current.api.getColumnState())
    let { newColDefs, autoGroupColumnDef } = syncColumnDefsWithColState({ colDefs: newColDefsRaw, autoColumnGroupDef: autoGroupColumnDefRaw, colState: colStateObj })
    selectedColumnCount = 1
    // find the max value of column number
    let maxNum = findMaxColNum(newColDefs)
    const columnToInsert = []
    for (let i = 0; i < noOfColumns; i++) {
        let newColumn={ "columnElasticid":uuidv4()+"_es", field: `Column${maxNum + 1}`, headerName: `Column ${maxNum + 1}`, colId: `Column ${maxNum + 1}`,width:300, minWidth:50,"columnType":"local", resizable:true,editable: true,deleteable:true,cellEditor:CustomCellEditor,cellEditorPopup:true,cellRenderer:CustomCellRenderer,filter:CustomTextNumberFilter,
        cellClass:(params) => {
            if(params.data){
                if(params.data[params.colDef.field+"_es"]){
                    return "global-style"+params.data[params.colDef.field+"_es"].format
                }
                else return "global-style"
                }
                else return "global-style"
        },
        cellStyle:(params)=>{
            let styles = {}
            if (params.data) {
                let cellInfo = { ...params.data[params.colDef.field + "_es"] }
                if (cellInfo && cellInfo.cellStyle && typeof cellInfo.cellStyle === 'object') {
                    styles = cellInfo.cellStyle 
                }
                let {color} = xTablesStore.getState().gridReducer
                if(cellInfo.updatedDate && HighlightBasedOnTimeRange(cellInfo.updatedDate)) styles={...styles,backgroundColor:color}
                return styles
            }
            return styles
        }
    }
        newColDefs.splice(currentColumnIndex, 0,newColumn);
        columnToInsert.push(newColumn)
        maxNum += 1
        currentColumnIndex += 1
    }
    let undoActivity = { "undoAction": 'delete', "redoAction": "insert", 'type': 'column', "index": columnIndex, "data": columnToInsert }
    const updatedColumnDefs = [newColDefs[0], autoGroupColumnDef, ...newColDefs.slice(1)]
    setColumnDefs({ colDefs: newColDefs, autoColumnGroupDefs: autoGroupColumnDef })
    await addColumnToIndex(columnIndex + 1, columnToInsert, '', updatedColumnDefs)
    setTimeout(() => callback(), 1000)
}
const updatePredecessorColumnValues = (rowData, predecessor,gridRef,col) => {
    if (col?.linkedColumns) {
        if ('successorNodes' in rowData) {
            delete rowData.successorNodes;
        }
        if ('predecessorNodes' in rowData) {
            delete rowData.predecessorNodes;
        }
    }
    if (rowData[predecessor]) {
        let { indexString } = getIndexesFromNodeArray(rowData[predecessor], gridRef.current);
        rowData[predecessor] = indexString;
        rowData[predecessor + '_es'].value = indexString;
    }
};
export function findColumnByColId(colDefs, key) {
    for (let col of colDefs) {
        if (col?.colId && col?.colId.includes(key)) {
            return col;
        }
        if (col?.children) {
            const found = findColumnByColId(col?.children, key);
            if (found) return found;
        }
    }
    return null;
}
// Recursive function to remove a column from nested children


function removeColumnFromNestedDefs(columns, colToRemove) {
    // Use a for loop so we can modify the array while iterating
    for (let i = columns.length - 1; i >= 0; i--) {
        const column = columns[i];

        if (column.field === colToRemove) {
            columns.splice(i, 1); // Remove matching column
        } else if (column.children) {
            // Recursively remove from children
            column.children = removeColumnFromNestedDefs(column.children, colToRemove);

            // If children array is empty after removal, remove the parent as well
            if (column.children.length === 0) {
                columns.splice(i, 1);
            }
        }
    }

    return columns;
}
export function getUpdatedDateRangeAfterDeletion(startDate, endDate, deleteColumnIdArray) {
    const deletedDatesSet = new Set(
      deleteColumnIdArray.map(d => new Date(d).toISOString().split("T")[0])
    );
  
    let newStart = new Date(startDate);
    let newEnd = new Date(endDate);
  
    // Move start date forward if it's deleted
    while (deletedDatesSet.has(newStart.toISOString().split("T")[0]) && newStart <= newEnd) {
      newStart.setDate(newStart.getDate() + 1);
    }
  
    // Move end date backward if it's deleted
    while (deletedDatesSet.has(newEnd.toISOString().split("T")[0]) && newEnd >= newStart) {
      newEnd.setDate(newEnd.getDate() - 1);
    }
  
    // Find the earliest deleted date within the remaining range
    const deletedDatesInRange = Array.from(deletedDatesSet)
      .map(d => new Date(d))
      .filter(d => d > newStart && d <= newEnd)
      .sort((a, b) => a - b);
     let endDateModified = false;
    if (deletedDatesInRange.length > 0) {
      const firstDeletedDate = deletedDatesInRange[0];
      newEnd = new Date(firstDeletedDate);
      newEnd.setDate(newEnd.getDate() - 1);
      endDateModified = true;
    }
  
    // if (newStart > newEnd) return { updatedStartDate: null, updatedEndDate: null };
  
    return {
        updatedStartDate: newStart,
        updatedEndDate: endDateModified?new Date(newEnd.getTime() + 24 * 60 * 60 * 1000):newEnd // add 1 day properly
      }
  }
  
  
  export function removeDeletedColumnFilters(filterMapping, columnsToDeleteArray) {
    if (!Array.isArray(filterMapping) || !Array.isArray(columnsToDeleteArray)) return [];
    const deletedColumnIds = columnsToDeleteArray.map(col => col.colDef.columnElasticid);
    return filterMapping
      .map(filterGroup => {
        const updatedFilters = (filterGroup.filters || []).filter(filter =>
          !deletedColumnIds.includes(filter.column?.columnElasticid)
        );
        return updatedFilters.length > 0
          ? { ...filterGroup, filters: updatedFilters }
          : null; // Remove the group if no filters left
      })
      .filter(Boolean); // Remove nulls
  }

export function deleteSelectedColumns(
    gridRef,
    undoStack,
    setColumnDefs,
    deleteColumn,
    setUndoStack,
    selectedColumns, // An array of columns to delete
    setRowData,
    updateColumnWithId,
    setSelectedColumns,
    deleteColumnsAPIFunction,
    focusedColumn,
    dispatch,
    isTimeSeriesColumnDeleted,
    predecessorcolumn,
    filterMapping,
    setFilterMapping,
    updatedBlockCol,
    clickSave
) {
    const newColDefsRaw = gridRef.current.props.columnDefs.slice();
    const autoGroupColumnDefRaw = gridRef.current.api.getColumnDef("ag-Grid-AutoColumn");
    let colStateObj = makeColStateObj(gridRef.current.api.getColumnState());
    let { newColDefs, autoGroupColumnDef } = syncColumnDefsWithColState({
        colDefs: newColDefsRaw,
        autoColumnGroupDef: autoGroupColumnDefRaw,
        colState: colStateObj
    });

    let undoStackArr = undoStack;
    let originalColumnDefs = deepCopy(newColDefs,['headerGroupComponent', 'headerGroupComponentParams']);
    let linkedColumnsBeforeColumnDelete = []
    let updatedColumnDefs = [...newColDefs];
    let updatedUndoStack = [...undoStack];
    let updatedRowData = [];
    gridRef.current?.api?.forEachNode(node => {
        updatedRowData.push({ ...node.data }); // Collect each row's data into the array
    });
    let rowsBeforeColumnDeletion = []
    let columnThatCannotBeDeleted = (col) => {
        if (col.block === 'timeseries' && col.parent) return true;
        
        }
    let columnsToDeleteArray = []
    let changedRowsAfterColumnDeletion = [], columnIndexArray = [];
    let parentColDef
    const processedPredecessorFields = new Set();
           
    selectedColumns.forEach(columnId => {
        if (columnId !== "ag-Grid-AutoColumn") {
            let focusedColumn = gridRef.current.api.getAllGridColumns().map(col => col.colDef)
            focusedColumn = findColumnByColId(focusedColumn, colStateObj[columnId].colId)
            let { predecessor } = focusedColumn?.linkedColumns || {};
             if (columnInstanceThatCannotBeDeleted(focusedColumn)) { 
                 renderAlert("One or more selected columns are part of a template and cannot be deleted.", "error");
                return;
            }
            if (columnThatCannotBeDeleted(focusedColumn)) { }
            if(isTimeSeriesColumnDeleted){
                
                //  parentColDef = findGroupByGroupId(updatedColumnDefs, focusedColumn.parent);
                parentColDef=updatedBlockCol;
                const colToRemove = focusedColumn?.field || "";
            
                if (parentColDef) {
                    let colDefObject = JSON.parse(parentColDef?.block);
                    let existingStart = new Date(colDefObject?.startDate);
                    let existingEnd = new Date(colDefObject?.endDate);
                    const { updatedStartDate, updatedEndDate } = getUpdatedDateRangeAfterDeletion(existingStart, existingEnd, [columnId]);
                    parentColDef.block = JSON.stringify({
                        ...JSON.parse(parentColDef.block),
                        startDate: updatedStartDate.toISOString(),
                        endDate: updatedEndDate.toISOString()
                      });
                      
                    // Remove the time series column from its group
                    let columnDefs = updatedColumnDefs.map((colDef) => {
                        if (colDef.colId === parentColDef.colId) {
                            return {
                                ...colDef,
                                block: parentColDef.block // updated block with new start and end dates
                            };
                        }
                        return colDef;
                    });
                    // // If parent has only one child with field === 'total', remove the entire parent
                    updatedColumnDefs = removeColumnFromNestedDefs(columnDefs, colToRemove);
                    // Track the deleted column
                    focusedColumn=sanitizeColumnDefs([focusedColumn])[0]
                    columnsToDeleteArray.push(JSON.parse(JSON.stringify(focusedColumn)));
                    if(parentColDef.children.length === 1 &&parentColDef.children[0].headerName === "Total"){
                        updatedColumnDefs = columnDefs.filter(col => col.colId !== parentColDef.colId);
                        columnsToDeleteArray.push(JSON.parse(JSON.stringify(parentColDef.children[0])));
                        columnsToDeleteArray.push(JSON.parse(JSON.stringify(parentColDef)));
                    }
                }
               // Clean up row data
                updatedRowData = updatedRowData.map(rowData => {
                    if (rowData[colToRemove]) {
                        const isAlreadyPresent = rowsBeforeColumnDeletion.some(row => row.id === rowData.id);
                        if (!isAlreadyPresent) {
                            rowsBeforeColumnDeletion.push(rowData);
                        }
                        const { [colToRemove]: value, [colToRemove + '_es']: value1, ...rest } = rowData;
                        changedRowsAfterColumnDeletion.push(rest);
                        return rest;
                    }
                    return rowData;
                });
            }
            else if (focusedColumn.parent) {
                let parentColDef = findGroupByGroupId(updatedColumnDefs, focusedColumn.parent)
                const colToRemove = focusedColumn?.field || "";

                if (focusedColumn.linkedColumns) {
                    let { columns, linkedColumnsBeforeUpdation } = removeLinkedColumns(updatedColumnDefs, focusedColumn.linkedColumns, updateColumnWithId, gridRef);                   
                    updatedColumnDefs = columns
                    if (linkedColumnsBeforeColumnDelete) {
                        // Loop through linkedColumnsBeforeUpdation
                        linkedColumnsBeforeUpdation.forEach(column => {
                            // Check if the column is not already in linkedColumnsBeforeColumnDelete
                            if (!linkedColumnsBeforeColumnDelete.some(existingColumn => existingColumn.field === column.field)) {
                                linkedColumnsBeforeColumnDelete.push(column); // Add the column
                            }
                        });
                    } else {
                        // If linkedColumnsBeforeColumnDelete does not exist, assign linkedColumnsBeforeUpdation
                        linkedColumnsBeforeColumnDelete = linkedColumnsBeforeUpdation;
                    }
                }
                focusedColumn=sanitizeColumnDefs([focusedColumn])[0]
                columnsToDeleteArray.push(JSON.parse(JSON.stringify(focusedColumn)))
                let updatedGroup = unGroupColumn({
                    gridRef,
                    undoStack,
                    params: { column: focusedColumn },
                    setColumnDefs,
                    updateColumnWithId,
                    deleteColumn,
                    addToRoot: false,
                    parentColDef,
                    dontCallDeleteAPI: updatedColumnDefs
                });
                if (updatedGroup) {
                    let { colIndex } = removeAColumnFromColumnDefs(updatedColumnDefs, updatedGroup?.groupId)
                    originalColumnDefs.forEach((columnDef, index) => {
                        if (columnDef?.colId && columnDef.colId === updatedGroup?.groupId) columnIndexArray.push(index)
                    })
                    if (colIndex !== undefined) {

                        if (updatedGroup.children.length === 0) { updatedColumnDefs.splice(colIndex, 1); columnsToDeleteArray.push(parentColDef) }
                        else updatedColumnDefs.splice(colIndex, 1, updatedGroup)
                    }
                }
                updatedRowData = updatedRowData.map(rowData => {
                    if (rowData[colToRemove]) { // Check if the rowData has a value in the column
                        const isAlreadyPresent = rowsBeforeColumnDeletion.some(
                            existingRow => existingRow.id === rowData.id
                        );

                        if (!isAlreadyPresent) {
                            rowsBeforeColumnDeletion.push(rowData)
                        }
                        updatePredecessorColumnValues(rowData, predecessor, gridRef, focusedColumn);
                        const { [colToRemove]: value, [colToRemove + '_es']: value1, ...rest } = rowData;
                        // Add the original rowData to undoRows before modifying it
                        changedRowsAfterColumnDeletion.push(rest);
                        return rest;
                    }
                    return rowData;
                });
            } else {
                let { slicedColumnDefs, colIndex } = removeAColumnFromColumnDefs(updatedColumnDefs, focusedColumn.colId)
                originalColumnDefs.forEach((columnDef, index) => {
                    if (columnDef?.colId && columnDef.colId === focusedColumn.colId) columnIndexArray.push(colIndex)
                })

                if (colIndex !== undefined) {
                    updatedColumnDefs.splice(colIndex, 1);
                }
                if (focusedColumn.linkedColumns) {
                    let { columns, linkedColumnsBeforeUpdation } = removeLinkedColumns(updatedColumnDefs, focusedColumn.linkedColumns, updateColumnWithId, gridRef);
                    updatedColumnDefs = columns
                    if (linkedColumnsBeforeColumnDelete) {
                        // Loop through linkedColumnsBeforeUpdation
                        linkedColumnsBeforeUpdation.forEach(column => {
                            // Check if the column is not already in linkedColumnsBeforeColumnDelete
                            if (!linkedColumnsBeforeColumnDelete.some(existingColumn => existingColumn.field === column.field)) {
                                linkedColumnsBeforeColumnDelete.push(column); // Add the column
                            }
                        });
                    } else {
                        // If linkedColumnsBeforeColumnDelete does not exist, assign linkedColumnsBeforeUpdation
                        linkedColumnsBeforeColumnDelete = linkedColumnsBeforeUpdation;
                    }
                    // removeLinkedColumns mutates live rowNode.data to convert predecessor UUID values to
                    // index strings, but updatedRowData is a snapshot taken before this. Sync it here so
                    // setGridOption('rowData', updatedRowData) doesn't overwrite those conversions.
                    // Use processedPredecessorFields to avoid double-conversion when multiple linked
                    // columns (e.g. Start Date + End Date) are deleted in the same operation.
                    if (predecessor && !processedPredecessorFields.has(predecessor)) {
                        processedPredecessorFields.add(predecessor);
                        const updatedRowMap = new Map(updatedRowData.map(r => [r.id, r]));
                        gridRef.current.api.forEachNode(node => {
                            if (!node.data.hasOwnProperty(predecessor)) return;
                            const rowInUpdated = updatedRowMap.get(node.data.id);
                            if (rowInUpdated) {
                                rowInUpdated[predecessor] = node.data[predecessor];
                                if (rowInUpdated[predecessor + '_es'] && node.data[predecessor + '_es']) {
                                    rowInUpdated[predecessor + '_es'].value = node.data[predecessor + '_es'].value;
                                }
                                delete rowInUpdated.successorNodes;
                                delete rowInUpdated.predecessorNodes;
                            }
                        });
                    }
                }
                if (focusedColumn.type === 'predecessor') {
                    removePredecessorAndSuccessorNodes(gridRef, focusedColumn,rowsBeforeColumnDeletion);
                }
                focusedColumn=sanitizeColumnDefs([focusedColumn])[0]
                columnsToDeleteArray.push(JSON.parse(JSON.stringify(focusedColumn)))
                // deleteColumn(focusedColumn, makeColumnArrayForDB(autoGroupColumnDef, updatedColumnDefs));
                const colToRemove = focusedColumn?.field || "";
                updatedUndoStack = updatedUndoStack.filter(row => !(row.columnInfo?.field === colToRemove));

                updatedRowData = updatedRowData.map(rowData => {
                    if (rowData[colToRemove]) { // Check if the rowData has a value in the column
                        const isAlreadyPresent = rowsBeforeColumnDeletion.some(
                            existingRow => existingRow.id === rowData.id
                        );

                        if (!isAlreadyPresent) {
                            rowsBeforeColumnDeletion.push(rowData)
                        }
                        updatePredecessorColumnValues(rowData, predecessor, gridRef);
                        const { [colToRemove]: value, [colToRemove + '_es']: value1, ...rest } = rowData;
                        changedRowsAfterColumnDeletion.push(rest);
                        return rest;
                    }
                    return rowData;;
                });
            }
        }
    });
    if(setSelectedColumns) setSelectedColumns([])
    const updatedFilterMapping = removeDeletedColumnFilters(filterMapping, columnsToDeleteArray.map((column) => { return { colDef: column } }));
    setFilterMapping(updatedFilterMapping)
    if(clickSave)clickSave()
   setTimeout(() => {
    deleteColumnsAPIFunction(columnsToDeleteArray.map((column) => { return { colDef: column } }), updatedColumnDefs)
   }, 300);
    
    setColumnDefs({
        colDefs: updatedColumnDefs,
        autoColumnGroupDefs: autoGroupColumnDef,
    });
   // setUndoStack([{ type: 'column', action: 'delete', previousRows: rowsBeforeColumnDeletion, cellRows: changedRowsAfterColumnDeletion, columnsForUndo: originalColumnDefs, columnsForRedo: updatedColumnDefs, autoColumnGroupDefs: autoGroupColumnDef, columnsToDeleteArray: columnsToDeleteArray, index: columnIndexArray, linkedColumnsBeforeColumnDelete: linkedColumnsBeforeColumnDelete }])
    //gridRef.current.api.setGridOption(updatedRowData);
    if (isTimeSeriesColumnDeleted) {
        let timeSeriesColumn = parentColDef        
        parentColDef=sanitizeColumnDefs([parentColDef])[0]
        updateColumnWithId(parentColDef)
        let totalColumn = parentColDef.children.find(child => child.headerName === 'Total' && child.block);
        const updatedRows = [];

        changedRowsAfterColumnDeletion.forEach((row) => {
            const { rowUpdatedWithTotal } = updateTotalIfValueIsChanged(timeSeriesColumn, totalColumn, { colDef: timeSeriesColumn }, row);
            if (rowUpdatedWithTotal) {
                updatedRows.push(rowUpdatedWithTotal);
            }
        });

        if (updatedRows.length > 0) {
            gridRef.current.api.applyTransaction({
                update: updatedRows,
            });
        }
    }
    if(changedRowsAfterColumnDeletion.length) 
    dispatch(categorizeAndStoreUpdatedRows({ update: changedRowsAfterColumnDeletion },gridRef))
    // dispatch({ type: XTABLES_ACTION_TYPES.SET_COLUMN_ORDER_CHANGED, columnOrderChanged: true })
    gridRef.current.api.setGridOption('rowData', updatedRowData);
}
  
export const makeColumnArrayForDB = (autoColumnGroupDef, columns) => {
    return [columns[0], autoColumnGroupDef, ...columns.slice(1)]
}
export const modifyColumn = (task = "hide", params, gridRef, undoList, columnWidthChanged, hideColumn, setColumnDefs, moveColumn, clickSave) => {
    //dragged | width change | hide
    if(params.finished!==true || params.source==="gridOptionsChanged" || params.source==='api') return;
    const newColDefs = gridRef.current.props.columnDefs
    let autoGroupColumnDef = gridRef.current.api.getColumnDef("ag-Grid-AutoColumn");
    if (newColDefs.length && params.column) {
        var colIdxToHide, colToHide,childColumnChanged
        for (let i = 0; i < newColDefs.length; i++) {
            if (params.column.colId === newColDefs[i].colId) { colIdxToHide = i; colToHide = newColDefs[i]; break; }
            else if(newColDefs[i].children) {
                for(let j=0; j < newColDefs[i].children.length;j++){
                    if (newColDefs[i].children[j].colId === params.column.colId) { 
                        colIdxToHide = i;
                        let modifiedChildren=[]
                        childColumnChanged = newColDefs[i].children[j];
                        if (task === 'width') {
                            childColumnChanged.width = params.column.actualWidth
                            if (j !== 0) modifiedChildren = newColDefs[i].children.slice(0, j)
                            modifiedChildren.push(childColumnChanged)
                            if (j !== newColDefs[i].children.length - 1) modifiedChildren = modifiedChildren.concat(newColDefs[i].children.slice(j + 1));
                        }
                        else if (task === 'dragged') {
                            let mainParent = recursivelyCalculateParent(params.column)
                            if (mainParent && mainParent.providedColumnGroup.colGroupDef.block) {
                                modifiedChildren = makeFirstColumnAlwaysVisibleUnderAGroup(mainParent.providedColumnGroup.colGroupDef.children)
                            }
                            else {
                                modifiedChildren = makeFirstColumnAlwaysVisibleUnderAGroup(params.column.parent.children)
                            }
                        }
                        colToHide = { ...newColDefs[i], children: modifiedChildren };
                        break;

                    }
                }
            }
        }
        if (params.column.colId === 'ag-Grid-AutoColumn') {
            if (task === 'width') {
                if (params.column.actualWidth != params.column.colDef.width) {
                    autoGroupColumnDef.width = params.column.actualWidth
                    columnWidthChanged(autoGroupColumnDef, makeColumnArrayForDB(autoGroupColumnDef, newColDefs))
                    setColumnDefs({ colDefs: newColDefs, autoColumnGroupDefs: autoGroupColumnDef })
                }
                else return
            }
        }
        if (!colToHide) return
        if (task === "hide") {
            colToHide.hide = !params.visible
            newColDefs.splice(colIdxToHide, 1, colToHide);
            hideColumn(colToHide, makeColumnArrayForDB(autoGroupColumnDef, newColDefs))
        }
        else if (task === 'width') {
            if (params.column.actualWidth != params.column.colDef.width) {
                if(!childColumnChanged) {colToHide.width = params.column.actualWidth;
                    newColDefs.splice(colIdxToHide, 1, colToHide);
                    columnWidthChanged(colToHide, makeColumnArrayForDB(autoGroupColumnDef, newColDefs))
                }
                else {
                    newColDefs.splice(colIdxToHide, 1, colToHide);
                    columnWidthChanged(childColumnChanged, makeColumnArrayForDB(autoGroupColumnDef, newColDefs))
                } 
                setColumnDefs({ colDefs: newColDefs })
            }
            else return
        }
        else if (task === 'dragged' && params.finished) {
            let dragToIndex=findDragToIndexForGroupColumn(params,newColDefs)
            newColDefs.splice(colIdxToHide, 1)
            if(params.column.parent && params.column.colDef.parent && params.column.parent.children.length) {
                newColDefs.splice(dragToIndex, 0, colToHide)
                setColumnDefs({colDefs:newColDefs})
                // Find the dragged child's new position in the reordered children.
                // colToHide.children are the column defs in new order (from makeFirstColumnAlwaysVisibleUnderAGroup).
                // The DB target is the preceding sibling, or the group header itself if the child moved to first.
                const childNewIndex = colToHide.children.findIndex(c => c.columnElasticid === childColumnChanged.columnElasticid)
                const targetForDB = childNewIndex > 0 ? colToHide.children[childNewIndex - 1] : colToHide
                if (targetForDB?.columnElasticid) {
                    moveColumn(childColumnChanged, colIdxToHide, targetForDB, makeColumnArrayForDB(autoGroupColumnDef, newColDefs), clickSave)
                }
                return
            } // if its a child col
            newColDefs.splice(dragToIndex, 0, colToHide)
            if (colIdxToHide + 1 === params.toIndex ) return
            setColumnDefs({ colDefs: newColDefs })

            // Build a flat column list matching DB order (group header followed by its children)
            // so that params.toIndex (a visual flat-column index from AG Grid) maps correctly
            // even when group columns are present. Without this, newColDefs[params.toIndex-1]
            // goes out of bounds whenever groups expand the visual column count beyond newColDefs.length.
            const flatCols = []
            newColDefs.forEach(col => {
                flatCols.push(col)
                if (col.children && col.children.length) {
                    col.children.forEach(child => flatCols.push(child))
                }
            })
            const fullFlat = [flatCols[0], autoGroupColumnDef, ...flatCols.slice(1)]
            const toIndex = params.toIndex > 0 ? fullFlat[params.toIndex - 1] : null
            if (!toIndex) return

            moveColumn(colToHide, colIdxToHide + 1, toIndex, makeColumnArrayForDB(autoGroupColumnDef, newColDefs),clickSave)
        }
        if (task === "hide") setColumnDefs({ colDefs: newColDefs, autoColumnGroupDefs: autoGroupColumnDef })
        const updatedColumnDefs = [autoGroupColumnDef, ...newColDefs];
    }
    else if(newColDefs.length && params.columns?.length){
        if (task === 'dragged' && params.finished){
            let colIndex=0,expectedChildrens=params.columns.map(column=>column.colDef.columnElasticid)
            let parentColumn,columnsBefore
            newColDefs.forEach((column,index)=>{
                columnsBefore++
                if(column.children && column.children.length){
                    column.children.forEach(child=>{
                        columnsBefore++
                        if(expectedChildrens.includes(child.columnElasticid)) {
                            colIndex=index;
                            parentColumn=column
                        }
                    })
                }
            });
            if(parentColumn){
                newColDefs.splice(colIndex,1)
                let dragToIndex=findDragToIndexForGroupColumn(params,newColDefs)
                newColDefs.splice(dragToIndex,0,parentColumn)
                setColumnDefs({ colDefs: newColDefs})
            }
            
        }
       
        // moveColumn(parentColumn, colIndex + 1, toIndex, makeColumnArrayForDB(autoGroupColumnDef, newColDefs))
    }
}

export const handleRowInsertion = (gridRef, insertRowFn, rowCount, undoStack, setUndoStack, setRedoStack, operationInProcess, setOperationInProcess, additionalParams, above = true, dispatch, isRowsInsertedForPaste, partialUndoRef) => {
    tracer.startActiveSpan("handleRowInsertion", context.active(), (span) => {
        let functionFlow = ["handleRowInsertion started"];
        let currentSheetRows = gridRef.current?.api.getModel().rowsToDisplay;
        let cell = gridRef.current.api.getFocusedCell();

        if (!cell) {
            console.error("No cell is currently focused.");
            return;
        }

        let updatedRowIndex = cell.rowIndex;
        let aboveNode = above ? currentSheetRows[cell.rowIndex - 1] : currentSheetRows[cell.rowIndex];
        functionFlow.push("insertMultipleRowsHelper called");
        insertMultipleRowsHelper(gridRef,
            insertRowFn,
            rowCount,
            setUndoStack,
            { above: above },
            operationInProcess,
            setOperationInProcess,
            updatedRowIndex,
            aboveNode,
            cell.column.getId(),
            isRowsInsertedForPaste,
            partialUndoRef
        )
        if (dispatch) scheduleGridToCardSync(gridRef, dispatch, true, 800);

        functionFlow.push("End of handleRowInsertion");
        span.setAttribute("function-flow", functionFlow);
    });
}

export const insertMultipleRowsHelper = async (gridRef, insertRow, numOfRows,  setUndoStack, options, operationInProcess, setOperationInProcess, cellIndex,  aboveNode,selectedColumnId,isRowsInsertedForPaste,partialUndoRef) => {
    const activeSpan = trace.getSpan(context.active());
    let functionFlow = ["insertMultipleRowsHelper started"];
    try {
        // Check if operation is in process
        if (operationInProcess) {
            functionFlow.push("Operation already in process, exiting.");
            activeSpan.setAttribute("insertMultipleRowsHelper-functionFlow", functionFlow);
            activeSpan.end();
            return;
        }
        setOperationInProcess(true);
        functionFlow.push("Operation in progress set to true");
        const focusRowAfterOperation =(addIndex)=>{
            functionFlow.push("Redrawing rows after operation");
            setTimeout(() => {
                gridRef.current.api.redrawRows();
                setTimeout(() => {
                    functionFlow.push("Setting operation in progress to false");
                    setOperationInProcess(false)
                }, 600);
                    if (addIndex && indexIsInCellRange(gridRef, { rowIndex: addIndex })) {
                        functionFlow.push(`Setting focused cell for row ${addIndex}`);
                        gridRef.current.api.setFocusedCell(addIndex, 'ag-Grid-AutoColumn', null);
                        gridRef.current.api.addCellRange({
                            rowStartIndex: addIndex,
                            rowEndIndex: addIndex,
                            columnStart: 'ag-Grid-AutoColumn',
                            columnEnd: 'ag-Grid-AutoColumn',
                        });
                    }
            }, 100);
        }
        functionFlow.push("Calling insertMultipleRowsCore");
        const coreResult = await insertMultipleRowsCore(gridRef, insertRow, numOfRows, options, cellIndex, aboveNode,selectedColumnId,focusRowAfterOperation,'',isRowsInsertedForPaste,partialUndoRef);
        if (!coreResult) {
            functionFlow.push("insertMultipleRowsCore returned null or undefined, ending operation.");
            setOperationInProcess(false);
            activeSpan.setAttribute("insertMultipleRowsHelper-functionFlow", functionFlow);
            activeSpan.end();
            return;
        }
        const { addIndex, undoInfo } = coreResult;
        functionFlow.push("insertMultipleRowsCore completed successfully");
        logSpan("insertMultipleRowsHelper undoStack", activeSpan.spanContext(),"INFO", formatInsertUndoInfoForLogs(undoInfo));
       if(setUndoStack) setUndoStack([
            undoInfo
        ]);
        functionFlow.push("Undo stack set");
        activeSpan.setAttribute("insertMultipleRowsHelper-functionFlow", functionFlow);
        activeSpan.end();
    }
    catch (e) {
        functionFlow.push("insertMultipleRowsHelper error");
        activeSpan.setAttribute("insertMultipleRowsHelper-functionFlow", functionFlow);
        gridRef.current.api.redrawRows();
        console.log("Error in inserting multiple rows", e);
        activeSpan.end();
    }
}

export const insertMultipleRows = (gridRef, insertRow, numOfRows, undoStack, setUndoStack, options,setRedoStack,operationInProcess,setOperationInProcess,updateCell,nodeStateMap,aboveNode) => {
    try {
    if(operationInProcess) return
    setOperationInProcess(true)
    const { above } = options
    let belowAddIndex;
    let currentSheetRows = gridRef.current?.api.getModel().rowsToDisplay;
    let selectedNodes = gridRef.current.api.getSelectedNodes() || gridRef?.current?.api?.getDisplayedRowAtIndex(currentSheetRows.length - 1);
    let cellRanges = gridRef.current.api.getCellRanges()
    let cell = updateCell?updateCell:gridRef.current.api.getFocusedCell() || gridRef?.current?.api?.getDisplayedRowAtIndex(currentSheetRows.length - 1)
    if (selectedNodes.length === 0) {
        if (cell) selectedNodes = [{ data: currentSheetRows[cell.rowIndex].data, rowIndex: cell.rowIndex }]
    }
    let selectedRowIndexes = getSelectedRowIndexes(gridRef);
    if (selectedRowIndexes.length === 0 && selectedNodes[0]) {
        selectedRowIndexes = [selectedNodes[0].rowIndex]
    }
    if (!above) {
        let selectedNode = currentSheetRows[selectedNodes[0].rowIndex]
        const childrenArray = getUniqueChildrenArray(selectedNode)

        if (childrenArray.length === 1) {
            belowAddIndex = selectedNode.rowIndex + 1;
        }
        else if(selectedNode.expanded){
            belowAddIndex = selectedNode.allChildrenCount + selectedNode.rowIndex+1
        }
        else if(selectedNode.expanded===false)
        {
            belowAddIndex=selectedNode.rowIndex+1;
        }
    }
    
    let smallestRowIndexSelected = getSmallestSelectedIndex(selectedRowIndexes);
    let prefixlid = currentSheetRows[smallestRowIndexSelected].data.l_id.split('.').slice(0, -1).join('.');
    let newRows = addMultipleRowsHelper(insertRow, numOfRows, prefixlid)
    if (newRows && newRows.length) {
        let temp=gridRef.current.api.applyTransaction({
            add: [...newRows],
            addIndex: above ? smallestRowIndexSelected : belowAddIndex
        })
        let parentRowsAffectedByRollup = [];
        const result = parentRowsAferRollup(newRows, gridRef, '', '')
        parentRowsAffectedByRollup = result.parentRowsAffectedByRollup;
        let additionalParentAndExtraRowsForUndo = result.additionalParentAndExtraRowsForUndo || [];
        let mergedRowsAfterRollupAndPredecessorChange = result.mergedRowsAfterRollupAndPredecessorChange;
        if(parentRowsAffectedByRollup.length){
            applyTransaction(gridRef,parentRowsAffectedByRollup)
        }
        let undoStackData = [];
        if (above) {
            for (let i = 0; i < newRows.length; i++) {
                undoStackData.push({ type: 'row', action: 'insert', index: temp.add[0].rowIndex + i })
            }
        } else {
            for (let i = 0; i < newRows.length; i++) {
                undoStackData.push({ type: 'row', action: 'insert', index: temp.add[0].rowIndex + i })
            }
        }
        setUndoStack([{ type: 'row', action: 'insertMultiple',allRowsAdded:newRows, addedRows: undoStackData,updatedRows:parentRowsAffectedByRollup,undoUpdatedRows:additionalParentAndExtraRowsForUndo,aboveNode:aboveNode, belowNodeId:currentSheetRows[smallestRowIndexSelected]?.id }])
        setTimeout(()=>{gridRef.current.api.redrawRows();
            setTimeout(()=>{
                setOperationInProcess(false)    
            },600)
            setTimeout(function(){
                if(temp?.add[0]?.rowIndex && indexIsInCellRange(gridRef,{rowIndex:temp.add[0].rowIndex})) {
                    gridRef.current.api.setFocusedCell(temp.add[0].rowIndex, 'ag-Grid-AutoColumn', null);
                    gridRef.current.api.addCellRange({
                        rowStartIndex: temp.add[0].rowIndex,
                        rowEndIndex: temp.add[0].rowIndex,
                        columnStart: 'ag-Grid-AutoColumn',
                        columnEnd: 'ag-Grid-AutoColumn',
                      });
                }  
            },0)
        },500)
    }
}
catch (e) {
    gridRef.current.api.redrawRows()
    console.log("Error in inserting multiple rows", e)
}
}

export const insertRowAbove = async ({ gridRef, undoStack, setRowData, insertRow, rowsObj, setSelectedCellHelper, renderAlert, setGridkey,operationInProcess,setOperationInProcess }) => {
    try {
        if(operationInProcess) return
        setOperationInProcess(true)
        let currentSheetRows = gridRef.current?.api.getModel().rowsToDisplay;
        let selectedNodes = gridRef.current.api.getSelectedNodes();
        let cell = gridRef.current.api.getFocusedCell()
        if (selectedNodes.length === 0) {
            if (cell) selectedNodes = [{ data: currentSheetRows[cell.rowIndex].data, rowIndex: cell.rowIndex }]
        }
        let selectedRowCount = selectedNodes.length;
        let selectedRowIndexes = getSelectedRowIndexes(gridRef);
        if (selectedRowIndexes.length === 0 && selectedNodes[0]) {
            selectedRowIndexes = [selectedNodes[0].rowIndex]
        }
        const currentSheetRowsData = currentSheetRows ? currentSheetRows : [];
        const undoStackData = [...undoStack]
        let smallestRowIndexSelected = getSmallestSelectedIndex(selectedRowIndexes);
        let prefixlid = currentSheetRows[smallestRowIndexSelected].data.l_id.split('.').slice(0, -1).join('.')
        let id = uuidv4()
        let newl_id = prefixlid ? prefixlid + '.' + id : id
        if (!validatel_id(newl_id, id, gridRef)) {
            { 
                // renderAlert('Something went wrong. We will reload the sheet for you.', 'error');
                //  loadGridForSometime(gridRef, setSelectedCellHelper, setGridkey); 
                 return; 
                }
        }
        let newRowData = currentSheetRowsData.slice();
        let rowsObject = rowsObj
        let temp = selectedNodes[selectedNodes.length - 1]

        let body = {
            l_id: newl_id
        }
        await insertRow( body, (content) => {
            body = { ...body, ...content }

            let row = {
                ...body, l_id: newl_id, id: id
               // ...body, l_id: newl_id, id: id,data:[]
            }
            let obj = row
            const undoActivity = { "undoAction": 'delete', "redoAction": "insert", 'type': 'row', "index": smallestRowIndexSelected, "data": row } 
            let temp=gridRef.current.api.applyTransaction({
                add: [obj],
                addIndex: smallestRowIndexSelected,
            });
            setTimeout(() => {
                gridRef.current.api.redrawRows();
                setTimeout(() => {
                    setOperationInProcess(false)
                }, 900)
            }, 1000)
            undoStackData.unshift({ type: 'row', action: 'insert', index: temp.add[0].rowIndex })
            setRowData({ undoStack: undoStackData, redoStack: [] })
            let autoGroupColumnDefRaw = cell.column.colDef;
            let currentFocusedCell={ rowIndex: temp.add[0].rowIndex, dbRowIndex: temp.add[0].rowIndex, sheetId: obj.sheet_id, rowId: obj.id, column: autoGroupColumnDefRaw, cellData: obj, cellDataForNotes: obj[autoGroupColumnDefRaw.field + '_es'] }
            setSelectedCellHelper(currentFocusedCell)
            setTimeout(function(){
                if(currentFocusedCell && indexIsInCellRange(gridRef,currentFocusedCell)) {
                    gridRef.current.api.setFocusedCell(temp.add[0].rowIndex, 'ag-Grid-AutoColumn', null);
                    gridRef.current.api.addCellRange({
                        rowStartIndex: temp.add[0].rowIndex,
                        rowEndIndex: temp.add[0].rowIndex,
                        columnStart: 'ag-Grid-AutoColumn',
                        columnEnd: 'ag-Grid-AutoColumn',
                      });
                }  
            },500)
        })

    } catch (error) {
        gridRef.current.api.redrawRows()
        console.log("Error in inserting the row above", error)
    }
}

export const insertRowBelow = async ({ gridRef, undoStack, setRowData, insertRow, rowsObj, setSelectedCellHelper, renderAlert, setGridkey }) => {
    try {
        let currentSheetRows = gridRef.current?.api.getModel().rowsToDisplay;
        let selectedNodes = gridRef.current.api.getSelectedNodes();
        let cell = gridRef.current.api.getFocusedCell()
        if (selectedNodes.length === 0) {
            if (cell) selectedNodes = [{ data: currentSheetRows[cell.rowIndex].data, rowIndex: cell.rowIndex }]
        }
        let selectedRowCount = selectedNodes.length;
        let selectedRowIndexes = getSelectedRowIndexes(gridRef);
        if (selectedRowIndexes.length === 0 && selectedNodes[0]) {
            selectedRowIndexes = [selectedNodes[0].rowIndex]
        }
        const currentSheetRowsData = currentSheetRows && currentSheetRows.length ? currentSheetRows : [];
        const undoStackData = [...undoStack]
        let largestRowIndexSelected = getLargestSelectedIndex(selectedRowIndexes);
        let selectedNode = currentSheetRows[selectedNodes[0].rowIndex];
        const childrenArray = getUniqueChildrenArray(selectedNode);

        if (childrenArray.length === 1) {
            largestRowIndexSelected = selectedNode.rowIndex + 1;
        }
        else if(selectedNode.expanded){
            largestRowIndexSelected = selectedNode.allChildrenCount + selectedNode.rowIndex+1
        }
        else if(selectedNode.expanded===false)
        {
            largestRowIndexSelected=selectedNode.rowIndex+1;
        }
        let prefixlid = currentSheetRows[largestRowIndexSelected-1].data.l_id.split('.').slice(0, -1).join('.')
        let id = uuidv4()
        let newl_id = prefixlid ? prefixlid + '.' + id : id
        if (!validatel_id(newl_id, id, gridRef)) {
            // renderAlert('Something went wrong. We will reload the sheet for you.', 'error');
            //  loadGridForSometime(gridRef, setSelectedCellHelper, setGridkey);
              return;
        }
        let newRowData = [...currentSheetRows];
        let rowsObject = rowsObj;
        let temp = selectedNodes[selectedNodes.length - 1]

        let body = {
            l_id: newl_id
        }
        await insertRow( body, (content) => {
            let row = {
                l_id: newl_id, id: id, ...body, ...content
            }
            let obj = row
            let temp=gridRef.current.api.applyTransaction({
                add: [obj],
                addIndex: largestRowIndexSelected,
            });
            undoStackData.unshift({ type: 'row', action: 'insert', index: temp.add[0].rowIndex })
            setRowData({ undoStack: undoStackData, redoStack: [] })
            setTimeout(()=>{gridRef.current.api.redrawRows()},200)
            let autoGroupColumnDefRaw = cell.column.colDef;
                setSelectedCellHelper({ rowIndex: temp.add[0].rowIndex , dbRowIndex: temp.add[0].rowIndex, sheetId: obj.sheet_id, rowId: obj.id, column: autoGroupColumnDefRaw, cellData: obj, cellDataForNotes: obj[autoGroupColumnDefRaw.field + '_es'] })
        })

    } catch (error) {
        gridRef.current.api.redrawRows()
        console.log("Error in inserting row below", error)
    }
}

export const getSelectedNodes = (gridRef, currentSheetRows) => {
    const cellRanges = gridRef.current.api.getCellRanges();
    let selectedNodes = gridRef.current.api.getSelectedNodes();
    if (cellRanges && cellRanges.length > 0) {
        cellRanges.forEach(range => {
            let start = Math.min(range.startRow.rowIndex, range.endRow.rowIndex);
            let end = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);
            for (let i = start; i <= end; i++) {
                const currentNode = currentSheetRows[i].id;
                // Check if the node already exists in selectedNodes
                const isAlreadySelected = selectedNodes.some(node => node.id === currentNode);
                if (!isAlreadySelected) {
                    selectedNodes.push(currentSheetRows[i]);
                }

            }
        });
    }
    // Sort selected nodes
    selectedNodes.sort((row1, row2) => parseInt(row1.rowIndex) - parseInt(row2.rowIndex));
    // If still no selected nodes, focus on the current cell
    if (selectedNodes.length === 0) {
        let cell = gridRef.current.api.getFocusedCell();
        if(cell)selectedNodes = [currentSheetRows[cell.rowIndex]];
    }
    return selectedNodes;
};

export const processAllNodesAndRemoveTheirPredecessorLinking =(rowsToDelete,gridRef,predecessorColumn)=>{
    if(!predecessorColumn) return []
    let rowsForUndo = [] , updatedRows = [] 
    let undoRowMap = {}
    rowsToDelete.forEach(row => {
        if (row?.data && row.data?.hasOwnProperty('predecessorNodes')) {
            let {nodesWithSuccessorUpdated,undoRowsSuccessor} = removeThisNodeAsSuccessorFromOtherRows(row.data.predecessorNodes, gridRef.current, row.id, [],{})
            if(nodesWithSuccessorUpdated.length > 0) {
                updatedRows= updatedRows.concat(nodesWithSuccessorUpdated);
                undoRowsSuccessor.forEach((undoRow) => {
                    if(!undoRowMap[undoRow.id]) undoRowMap[undoRow.id] = undoRow
                })
            }
        }
        if(row.data && row.data?.hasOwnProperty('successorNodes')){
            let {nodesWithPredecessorUpdated,undoRowsPredecessor} = removeThisNodeAsPredecessorFromOtherRows(row.data.successorNodes, gridRef.current, row.id, [],{},predecessorColumn.field)
            if(nodesWithPredecessorUpdated.length > 0) {
                updatedRows= updatedRows.concat(nodesWithPredecessorUpdated);
                undoRowsPredecessor.forEach((undoRow) => {
                    if(!undoRowMap[undoRow.id]) undoRowMap[undoRow.id]= undoRow
                })
            }
        }
                
    });
    Object.keys(undoRowMap).forEach((id)=>{
        let undoRow = undoRowMap[id]
        rowsForUndo.push(undoRow)
    })
    return {extraRowsForPredecessor : updatedRows,undoRows:rowsForUndo}
}

export const getUniqueParentSetOfAllRows =(rows,gridRef) => {
    let parentSet = new Set(),parentMap ={};
    rows.forEach((row)=>{
        let node = gridRef.current.api.getRowNode(row.id);
        let parentRows = getAllParentsOfANode(node);
        parentRows.forEach((parentRow)=>{
        // if(!parentMap[parentRow.id])
            parentSet.add(parentRow)
        })
    })
    return parentSet
}
export const supportRollupForParentNodes = (deletedRows,gridRef,predecessorcolumn)=>{
    
    // let abc = parentRowsAferRollup(parentSet,gridRef,predecessorColumn)
    let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo,mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup([], gridRef, predecessorcolumn)
    return { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo,mergedRowsAfterRollupAndPredecessorChange }
}

export const determineRowsToDelete = (selectedNodes, gridRef, setSuccessorNodesForRowUndo,predecessorColumn) => {
    let rowsToDelete = [];
    let selectedRowIndexes = [];
    let successorNodesForRowUndo = []
    let count =0;
    selectedNodes.forEach((row) => {
        // Always add the selected row to rowsToDelete
        if (row?.data && row.data?.hasOwnProperty('successorNodes')) {
            const successorNodesIds = row.data['successorNodes'].split(',');

            // Example: Iterate through the IDs and perform some action
            successorNodesIds.forEach(id => {
                const rowNode = gridRef.current.api.getRowNode(id);
                successorNodesForRowUndo.push(rowNode)
            })
        }
        rowsToDelete.push(row);
        const childrenArray = getUniqueChildrenArray(row)

        if (childrenArray && childrenArray.length > 0) {
            // If it's a parent, store its index
            if (!selectedRowIndexes.includes(row.rowIndex+count)) {
                selectedRowIndexes.push(row.rowIndex+count);
            }
            // Add children to rowsToDelete
           let childCount = 0;
            childrenArray.forEach((child) => {
                if (child.data.l_id.includes(row.data.id)) {
                    if (row.rowIndex !== child.rowIndex) {
                        if(child.rowIndex === null ){
                            ++count; 
                            let difference = childCount-1;
                            childCount--;
                            if( !selectedRowIndexes.includes(row.rowIndex+difference+count))
                                selectedRowIndexes.push(row.rowIndex+difference+count); 
                        }
                        else if(!selectedRowIndexes.includes(child.rowIndex+count) && child.rowIndex !== null) {
                            selectedRowIndexes.push(child.rowIndex + count);
                        } 
                        
                    }
                    childCount++;
                    rowsToDelete.push(child);
                }
            });
        } else {
            if (!selectedRowIndexes.includes(row.rowIndex)) {
                selectedRowIndexes.push(row.rowIndex);
            }
        }
    });
    selectedRowIndexes.sort((a, b) => a - b);
    // Check continuity in the original order (ascending or descending as selected)
    const isContinuous = selectedRowIndexes.every((val, index) => {
        return index === 0 || Math.abs(val - selectedRowIndexes[index - 1]) === 1;
    });
    // If not continuous, keep the original order and only select the first row index
    // if (isContinuous) {
    //     selectedRowIndexes = selectedRowIndexes[0];
    // }
    // Remove duplicates from rowsToDelete
    rowsToDelete = rowsToDelete.reduce((acc, current) => {
        if (!acc.find(item => item.id === current.id)) {
            acc.push(current);
        }
        return acc;
    }, []);
    if(predecessorColumn){
        var {extraRowsForPredecessor,undoRows} = processAllNodesAndRemoveTheirPredecessorLinking(rowsToDelete,gridRef,predecessorColumn)
        // if(extraRowsForPredecessor?.length>0) successorNodesForRowUndo = successorNodesForRowUndo.concat(extraRowsForPredecessor)
    }
    setSuccessorNodesForRowUndo(successorNodesForRowUndo)
    return { rowsToDelete, selectedRowIndexes,extraRowsForPredecessor:extraRowsForPredecessor || [],undoRowsForPredecessor : undoRows ,successorNodesForRowUndoForRowDelete:successorNodesForRowUndo };
};

export const prepareUndoStack = (undoData) => {
        const {rowsToDelete, selectedRowIndexes, successorNodesForRowUndo, aboveNode, extraRowsForPredecessor, undoRowsForPredecessor, parentRowsAffectedByRollup, addedRowsAfterDeletion} = undoData
    const undoRows = [...rowsToDelete];
    return { type: 'row', action: 'delete', rowData: undoRows, index: selectedRowIndexes, successorNodesForRowUndo: successorNodesForRowUndo, extraRowsForPredecessor, undoRowsForPredecessor, aboveNode: aboveNode, rolledUpRows: parentRowsAffectedByRollup, addedRowsAfterDeletion: addedRowsAfterDeletion };
};

export const deleteRowsFromGrid = (gridRef, rowsToDelete) => {
    let deletedRows = gridRef.current.api.applyTransaction({ remove: rowsToDelete });
    return deletedRows.remove
};

export const handleEmptyGrid = (gridRef, insertRow, setSelectedCellHelper, setOperationInProcess, dispatch, span, onComplete) => {
    const currentSpan = tracer.startSpan("handleEmptyGrid", {
        parent: span?.spanContext?.()
    });
    let functionFlow = ["handleEmptyGrid started"]
    let addedRows = [];
    // setTimeout(() => { // removed setTimeout as gridRef was coming null when last multiple rows deleted
        functionFlow.push("Inside setTimeout")
        try {
            if (gridRef.current.api.getModel().rootNode.allLeafChildren.length === 0) {
                functionFlow.push("Adding extra rows")
                let newRows = addMultipleRowsHelper(insertRow, 50);
                if (newRows && newRows.length) {
                    functionFlow.push("New rows transaction")
                    let addedTransactionRows = gridRef.current.api.applyTransaction({ add: newRows });
                    dispatch(categorizeAndStoreUpdatedRows({ add: { addedRows: newRows, belowNodeId: 'none' } },gridRef))
                    addedRows = addedTransactionRows.add?.map(row => row.data)
                    functionFlow.push("New rows added")
                }
            }
            setSelectedCellHelper();
            gridRef.current.api.clearFocusedCell();
            gridRef.current.api.deselectAll();
            gridRef.current.api.clearRangeSelection();
            gridRef.current.api.redrawRows();
            if(setOperationInProcess) setOperationInProcess(false);
            if (onComplete) {
                functionFlow.push("Inside onComplete")
                onComplete(addedRows); // Execute callback with the added rows
            }
            functionFlow.push("handleEmptyGrid.try completed");
        } catch(error) {
            functionFlow.push("handleEmptyGrid error");
            logSpan("handleEmptyGrid-error", currentSpan.spanContext(),"ERROR", error);
            currentSpan.setAttribute("handleEmptyGrid.error", error);
        } finally {
            functionFlow.push("handleEmptyGrid finally");
            currentSpan.setAttribute(`handleEmptyGrid-functionFlow:${Math.random}`, functionFlow);
            currentSpan.end();
        }
    // }, 900);
};

export const getPredecessorColumnUsingGridRef=(gridRef)=>{
    let allColumns = gridRef?.current?.api?.getColumnDefs()
    let predecessorColumn = findColumnByTypeOrField(allColumns,'predecessor')
    return predecessorColumn
}
export const deleteSelectedRowsWithChildSupport = async ({
    gridRef,
    undoStack,
    setUndoStack,
    setSelectedCellHelper,
    setRedoStack,
    insertRow,
    operationInProcess,
    setOperationInProcess,
    dispatch,
    setSuccessorNodesForRowUndo,
    predecessorColumn

}) => {
    if (operationInProcess) return;
    const activeSpan = trace.getSpan(context.active());
    let functionFlow = ["deleteSelectedRowsWithChildSupport started"];
    try {
        setOperationInProcess(true);
        functionFlow.push("prepareRowDeletion called");
        const { undoData, error } = await prepareRowDeletion(
            gridRef,
            insertRow,
            setSelectedCellHelper,
            dispatch,
            setSuccessorNodesForRowUndo,
            predecessorColumn
        );
        logSpan("deleteSelectedRowsWithChildSupport-undoStack", activeSpan.spanContext(), "INFO", formatDeleteUndoInfo(undoData), error);
        if (error || !undoData) {
            console.warn("Row deletion aborted:", error);
            functionFlow.push("deleteSelectedRowsWithChildSupport-aborted");
            activeSpan.setAttribute("deleteSelectedRowsWithChildSupport-functionFlow", functionFlow);
            activeSpan.end();
            return;
        }

        // Push to undoStack outside the child
        setUndoStack([prepareUndoStack(undoData)]);
        setRedoStack([]);

    } catch (error) {
        functionFlow.push("deleteSelectedRowsWithChildSupport error");
        logSpan("deleteSelectedRowsWithChildSupport-error", activeSpan.spanContext(), "ERROR", error);
        activeSpan.end();
        gridRef.current.api.redrawRows();
    } finally {
        functionFlow.push("deleteSelectedRowsWithChildSupport end");
        activeSpan.setAttribute("deleteSelectedRowsWithChildSupport-functionFlow", functionFlow);
        activeSpan.end();
        setOperationInProcess(false);
    }
};
function setFocusedCellAfterOperation (index,gridRef)  {
    gridRef.current.api.setFocusedCell(index, '#', null);
    gridRef.current.api.addCellRange({
        rowStartIndex: index,
        rowEndIndex: index,
        columnStart: '#',
        columnEnd: '#'
    });
}
// Main Function

export const onRowDragEnd = async (e, params) => {    
    const {
        rowData,
        dragStartIndex,
        draggedOverIndex,
        gridRef,
        renderAlert,
        setUndoStack,
        setDisableIndentOutdent,
        setOperationInProcess,
        operationInProcess,
        predecessorcolumn,dispatch
    } = params;
    if (operationInProcess) return;
    try {
        setOperationInProcess(true);
        let  {dropIndex,undoInfo, collapseDraggedNode = false}  = await handleRowDragOperation({
            draggedNode: e.node,
            dragStartIndex,
            dragOverIndex: e.overIndex,
            overNode: e.overNode,
            gridRef, 
            renderAlert,
            setUndoStack,
            predecessorcolumn,
            direction: draggedOverIndex.direction,
            setOperationInProcess
        });
       scheduleGridToCardSync(gridRef, dispatch, true);
        if(undoInfo) setUndoStack([undoInfo])
        setTimeout(() => {
            gridRef.current.api.redrawRows();
            setDisableIndentOutdent(false);
            if (dropIndex && dropIndex !== -1) {
                gridRef.current.api.clearRangeSelection();
                setFocusedCellAfterOperation(dropIndex,gridRef);
            }
            setTimeout(() => setOperationInProcess(false), 100);
        }, 500);
        if(collapseDraggedNode){
            setTimeout(() => {
                let currentSheetRows = gridRef.current.api.getModel().rowsToDisplay;
                if (currentSheetRows[dropIndex].expanded === true) {
                    let collapseRow = getUniqueChildrenArray(currentSheetRows[dropIndex]);
                    collapseRow.forEach((node) => {
                        gridRef.current.api.setRowNodeExpanded(node, false);
    
                    });
                }
            }, 600);}
    } catch (error) {
        console.error(error);
        gridRef.current.api.redrawRows();
        setOperationInProcess(false);
    }
};


export const undoEditChanges = async ({ currentSheetRows, undoStack, redoStack, setRowData, row, gridRef, cellValueChanged, sheetType, setRedoStack, setUndoStack }) => {
    let curr_Data = { ...undoStack[0] }
    let data = currentSheetRows
    let splicedData = data[row.index]
    curr_Data.rowData = splicedData.data
    curr_Data.value = curr_Data.rowData[curr_Data.columnInfo.field]
    // cellValueChanged({newValue:row.value,rowIndex:row.index,sheetRowId:row.sheetrowid,row:row.rowData,columnId:row.column,columnType:row.columnInfo.columnType,sheetType:sheetType,typeSpecificData:row.typeSpecificData,rowMetaData:row.rowData})
    let newUndoStack = undoStack
    let newRedoStack = [curr_Data, ...redoStack]
    newUndoStack = newUndoStack.slice(1)
    setUndoStack(newUndoStack,true)
    setRedoStack(newRedoStack,true)
    gridRef.current.api.applyTransaction({
        update: [row.rowData],
        addIndex: row.index
    });
    gridRef.current.api.redrawRows()
}
export const redoEditChanges = async ({ currentSheetRows, undoStack, redoStack, setRowData, row, gridRef, cellValueChanged, sheetType, setRedoStack, setUndoStack }) => {
    let curr_Data = { ...redoStack[0] }
    let data = currentSheetRows
    let splicedData = data[row.index]
    curr_Data.rowData = splicedData.data
    curr_Data.value = curr_Data.rowData[curr_Data.columnInfo.field]
    // cellValueChanged({newValue:row.value,rowIndex:row.index,sheetRowId:row.sheetrowid,row:row.rowData,columnId:row.column,columnType:row.columnInfo.columnType,sheetType:sheetType,typeSpecificData:row.typeSpecificData,rowMetaData:row})
    let newRedoStack = redoStack
    newRedoStack = newRedoStack.slice(1)
    let newUndoStack = [curr_Data, ...undoStack]
    setRedoStack(newRedoStack,true)
    setUndoStack(newUndoStack,true)
    gridRef.current.api.applyTransaction({
        update: [row.rowData],
        addIndex: row.index
    });
}
export const undoTransactionChanges = async ({ undoStack, redoStack, row, gridRef, setSelectedCellHelper, setRedoStack, setUndoStack,operationInProcess,setOperationInProcess }) => {
    if(operationInProcess)return
    setOperationInProcess(true)
    setRedoStack([{ type: "row", action: "transaction", cellRows: row.cellRows, index: row.index, previousRows: row.previousRows,dontSelectCell:row.dontSelectCell }],true)
    gridRef.current.api.applyTransaction({
        update: row.previousRows,
        addIndex: row.index
    });
    console.log("Undo transaction",row, row.previousRows)
    setTimeout(() => {
        let focusedCell = gridRef.current.api.getFocusedCell();
             gridRef.current.api.redrawRows();
        if(row.dontSelectCell!==true)
        {
            gridRef.current.api.clearRangeSelection()
            setTimeout(() => {
                gridRef.current.api.setFocusedCell(row.index, 'ag-Grid-AutoColumn', null);
                gridRef.current.api.addCellRange({ rowStartIndex: row.index, rowEndIndex: row.index, columnStart: 'ag-Grid-AutoColumn', columnEnd: 'ag-Grid-AutoColumn' })
            }, 50)
        }
    }, 0)
    setTimeout(()=>{setOperationInProcess(false)},2200)
    setUndoStack([],true)
}
export const undoWrapChanges = async ({ undoStack, redoStack, row, gridRef, setRedoStack, setUndoStack }) => {
    setRedoStack({ type: 'row', action: 'wrap', previousRows: row.cellRows, cellRows: row.previousRows, index: row.index },true)
    gridRef.current.api.applyTransaction({
        remove: row.cellRows,
    });
    gridRef.current.api.applyTransaction({
        add: row.previousRows,
        addIndex: row.index
    });
    setTimeout(() => { gridRef.current.api.redrawRows() }, 0)
    setUndoStack([],true)
}
export const undoDragRow = async ({ undoStack, redoStack, gridRef, row, setUndoStack, setRedoStack }) => {
    const isReversed = row.rowData[0].id !== row.cellRows[0].id;
    if (isReversed) {
        row.cellRows.reverse();
    }
    let nodeStateMap1 = new Map(); let nodeStateMap2 = new Map();
    if (row.aboveNode) {
        nodeStateMap1 = expandAboveNode(row.aboveNode, gridRef);
    }
    if (row.fromIndexAboveNode) {
        nodeStateMap2 = expandAboveNode(row.fromIndexAboveNode, gridRef);
    }
    setTimeout(() => {
        let { action, rowData, index, overIndex } = undoStack[0]
        if (action === 'drag') {
            gridRef.current.api.applyTransaction({
                remove: row.cellRows,
            });
            let dropIndex = gridRef.current.api.applyTransaction({
                add: row.rowData,
                addIndex: index
            });
            let belowNodeId
            // calculate belowNode
            let rowData = gridRef.current.api.getModel().rootNode.allLeafChildren;
            let droppedNodeIndex = dropIndex.add.reduce((acc, curr) => {
                return Math.max(acc, curr.sourceRowIndex);
            }, 0);
            if(droppedNodeIndex ||droppedNodeIndex===0) {
                let nodeBelow = rowData[droppedNodeIndex + 1];
                belowNodeId= nodeBelow?.id||'none'
            };

            let collapsedChildren = []
            row.rowData.forEach((row) => {
                if (row.collapsed === true) collapsedChildren.push(row);
            })
            if (collapsedChildren && collapsedChildren.length) {
                collapsedChildren.forEach((node) => {
                    gridRef.current.api.setRowNodeExpanded(gridRef.current.api.getModel().nodeManager.allNodesMap[node.id], false)
                })
            }
            setTimeout(() => {
                if (row.previousRows) {
                    gridRef.current.api.applyTransaction({
                        update: row.previousRows,
                    });
                }
                gridRef.current.api.redrawRows();
                setUndoStack([],true);
                // let indexing = row.aboveNode?.allChildrenCount
                //     ? overIndex + row.aboveNode.allChildrenCount + (row.fromIndex?.allChildrenCount || 0)
                //     : overIndex + (row.fromIndex?.allChildrenCount || 0);
                setRedoStack([{ type: 'row', action: 'drag', rowData: row.cellRows, cellRows: row.rowData, index: overIndex, overIndex: index, aboveNode: row.aboveNode, fromIndexAboveNode: row.fromIndexAboveNode, previousRows: row.updatedRows, updatedRows: row.previousRows , belowNodeId }],true)
            }, 0)
            setTimeout(() => {
                if (row.aboveNode) collapseAboveNode(row.aboveNode, gridRef, nodeStateMap1);
                if (row.fromIndexAboveNode) collapseAboveNode(row.fromIndexAboveNode, gridRef, nodeStateMap2);
            }, 0);

        }
    }, 50);

}
export const redoDragRow = async ({ undoStack, redoStack, gridRef, row, setUndoStack, setRedoStack }) => {
    const isReversed = row.rowData[0].id !== row.cellRows[0].id;
    if (isReversed) {
        row.cellRows.reverse();
    }
    let nodeStateMap1 = new Map(); let nodeStateMap2 = new Map();
    if (row.aboveNode) {
        nodeStateMap1 = expandAboveNode(row.aboveNode, gridRef);
    }
    if (row.fromIndexAboveNode) {
        nodeStateMap2 = expandAboveNode(row.fromIndexAboveNode, gridRef);
    }
    setTimeout(() => {
        let { action, rowData, index, overIndex } = redoStack[0]
        if (action === 'drag') {
            gridRef.current.api.applyTransaction({
                remove: row.cellRows,
            });
          let dropIndex = gridRef.current.api.applyTransaction({
                add: row.rowData,
                addIndex: index
            });

            let belowNodeId
            // calculate belowNode
            let rowData = gridRef.current.api.getModel().rootNode.allLeafChildren;
            let droppedNodeIndex = dropIndex.add.reduce((acc, curr) => {
                return Math.max(acc, curr.sourceRowIndex);
            }, 0);
            if(droppedNodeIndex||droppedNodeIndex==0) {
                let nodeBelow = rowData[droppedNodeIndex + 1];
                belowNodeId= nodeBelow?.id||'none'
            };


            let collapsedChildren = []
            row.rowData.forEach((row) => {
                if (row.collapsed === true) collapsedChildren.push(row);
            })
            if (collapsedChildren && collapsedChildren.length) {
                collapsedChildren.forEach((node) => {
                    gridRef.current.api.setRowNodeExpanded(gridRef.current.api.getModel().nodeManager.allNodesMap[node.id], false)
                })
            }
            setTimeout(() => {
                if (row.previousRows) {
                    gridRef.current.api.applyTransaction({
                        update: row.previousRows,
                    });
                }
                gridRef.current.api.redrawRows(); setRedoStack([],true);
                 setUndoStack([{ type: 'row', action: 'drag', rowData: row.cellRows, cellRows: row.rowData, index: overIndex, overIndex: index, aboveNode: row.aboveNode, fromIndexAboveNode: row.fromIndexAboveNode, previousRows: row.updatedRows, updatedRows: row.previousRows , belowNodeId }],true)
            }, 0)
            setTimeout(() => {
                if (row.aboveNode) collapseAboveNode(row.aboveNode, gridRef, nodeStateMap1);
                if (row.fromIndexAboveNode) collapseAboveNode(row.fromIndexAboveNode, gridRef, nodeStateMap2);

            }, 10);

        }
    }, 50);

}
// Helper function to update node IDs and special column fields
const updateNodeIds = (rowData, oldIdToNewIdMap, predecessorColumn) => {
    ['predecessorNodes', 'successorNodes'].forEach(key => {
        if (rowData[key]) {
            rowData[key] = rowData[key].split(',')
                .map(nodeId => oldIdToNewIdMap[nodeId] || nodeId)
                .join(',');
        }
    });

    if (predecessorColumn && rowData[predecessorColumn.field]) {
        rowData[predecessorColumn.field] = rowData[predecessorColumn.field]
            .split(',')
            .map(predecessorId => {
                let newId = oldIdToNewIdMap[predecessorId];
                if (newId) {
                    let [id] = predecessorId.split('+');
                    return newId + (predecessorId.includes('+') ? '+' + predecessorId.split('+')[1] : '');
                }
                return predecessorId;
            })
            .join(',');

        // Check if '_es' field exists, if not, create it
        if (!rowData.hasOwnProperty(predecessorColumn.field + '_es')) {
            rowData[predecessorColumn.field + '_es'] = {
                value: rowData[predecessorColumn.field]
            };
        } else {
            // Update the existing '_es' field
            rowData[predecessorColumn.field + '_es'].value = rowData[predecessorColumn.field];
        }
    }
};
// Main function
export const undoDeleteRow = async ({ row, gridRef, undoStack, redoStack, currentSheetRows, currentRowsObject, setRowData, insertRow, columnDefs, setUndoStack, setRedoStack, successorNodesForRowUndo, setSuccessorNodesForRowUndo,dispatch }) => {
    let nodeStateMap  = new Map();
    if(row.aboveNode){
        nodeStateMap = expandAboveNode(row.aboveNode,gridRef);}
        setTimeout(() => {
          let newRedoVal = { ...undoStack[0] };
    let index = newRedoVal.index;  // Could be a string or an array
    let oldIdToNewIdMap = {};
    let rowsToInsert = [];
    const predecessorColumn = columnDefs.find(colDef => colDef.type === 'predecessor');

   
    // Update row data with new IDs and process insertions
    row.rowData.forEach((row) => {
        // Add to rows to insert
        insertRow( { ...row.data }, (content) => rowsToInsert.push(row.data));
    });

    // Insert the updated rows back into the grid
    let newRedoStack = [newRedoVal, ...redoStack];
    const rowData = row.rowData; // This is an array of row nodes
    let transitionedRowsAdded = []
    let addIndex;
    try {
        rowData.forEach((rowNode, position) => {
            // Determine the index based on whether newRedoVal.index is a string or array
            if (Array.isArray(index)) {
                addIndex = (index[position] !== undefined) ? index[position] : rowNode.childIndex;
            } else {
                addIndex = index + position;  // Use the string directly
            }
            rowNode.data = rowsToInsert[position]
            let transitionedRows = gridRef.current.api.applyTransaction({
                add: [rowsToInsert[position]],
                addIndex: addIndex,
            });

            transitionedRowsAdded = transitionedRowsAdded.concat(transitionedRows.add.map((row) => row.data));

        });
    } catch (error) {
                console.error('Error in forEach loop:', error);
            }
            if (row?.addedRowsAfterDeletion && row.addedRowsAfterDeletion.length > 0) {
                gridRef.current.api.applyTransaction({
                    remove: row.addedRowsAfterDeletion,
                });
                dispatch(categorizeAndStoreUpdatedRows({ delete: row.addedRowsAfterDeletion },gridRef))
            }
            if (row.undoRowsForPredecessor && row.undoRowsForPredecessor.length > 0) {
                // Apply transaction for updated successor nodes
                gridRef.current.api.applyTransactionAsync({
                    update: row.undoRowsForPredecessor,
                });
            }
            let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(transitionedRowsAdded, gridRef, predecessorColumn)
            let changedRows = []
            if (parentRowsAffectedByRollup) changedRows = changedRows.concat(mergedRowsAfterRollupAndPredecessorChange)
            if (changedRows.length) applyTransaction(gridRef, changedRows);
            setTimeout(() => gridRef.current.api.redrawRows(), 500);
            setUndoStack([], true);
            setRedoStack([{ type: "row", action: "delete", rowsToRemove: rowsToInsert, undoRows: row.rowData, index: row.index, successorNodesForRowUndo: successorNodesForRowUndo, aboveNode: row.aboveNode, undoRowsForPredecessor: row.undoRowsForPredecessor, extraRowsForPredecessor: row.extraRowsForPredecessor, belowNodeId: row?.addedRowsAfterDeletion ? 'none' : currentSheetRows[addIndex]?.id ? currentSheetRows[addIndex]?.id : 'none', rolledUpRows: parentRowsAffectedByRollup, addedRowsAfterDeletion: row.addedRowsAfterDeletion }], true);
            setTimeout(() => {
                if (row.aboveNode) collapseAboveNode(row.aboveNode, gridRef, nodeStateMap);
            }, 10);
        }, 50);
};

export const redoDeleteRow = async ({ row, gridRef, undoStack, redoStack, currentSheetRows, setRowData, deleteRow, setUndoStack, setRedoStack, insertRow, dispatch }) => {
    let nodeStateMap = new Map();
    if (row.aboveNode) {
        nodeStateMap = expandAboveNode(row.aboveNode, gridRef);
    }
    setTimeout(() => {
        let uniqueParentsOfAllRows = getUniqueParentSetOfAllRows(row.rowsToRemove, gridRef)
        let removedRows = gridRef.current.api.applyTransaction({
            remove: row.rowsToRemove,
        });
        let addedTransactionRows;
        if (row.addedRowsAfterDeletion.length > 0) {
            let newRows = addMultipleRowsHelper(insertRow, 50);
            if (newRows && newRows.length) {
                addedTransactionRows = gridRef.current.api.applyTransaction({ add: newRows });
                dispatch(categorizeAndStoreUpdatedRows({ add: { addedRows: newRows, belowNodeId: 'none' } },gridRef))
            }
        }
        setUndoStack([{ type: "row", action: "delete", rowData: row.undoRows, index: row.index, successorNodesForRowUndo: row.successorNodesForRowUndo, aboveNode: row.aboveNode, undoRowsForPredecessor: row.undoRowsForPredecessor, extraRowsForPredecessor: row.extraRowsForPredecessor, addedRowsAfterDeletion: row?.addedRowsAfterDeletion?.length > 0? addedTransactionRows.add.map(row => row.data):[] }], true)

        if (row.extraRowsForPredecessor && row.extraRowsForPredecessor.length > 0) {
            // Apply transaction for updated successor nodes
            gridRef.current.api.applyTransactionAsync({
                update: row.extraRowsForPredecessor,
            });
        }

    let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo,mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup([],gridRef,'',uniqueParentsOfAllRows)
    if ( parentRowsAffectedByRollup) applyTransaction(gridRef, mergedRowsAfterRollupAndPredecessorChange);
    setTimeout(() => gridRef.current.api.redrawRows(), 0)
    setTimeout(() => {
    if(row.aboveNode) collapseAboveNode(row.aboveNode,gridRef,nodeStateMap);    
    }, 0);
    
    setRedoStack([],true)  
     }, 50);
    
}

export const undoInsertMultipleRows = ({ currentSheetRows, undoStack, row, gridRef, setRedoStack, setUndoStack }) => {
    let nodeStateMap = new Map();
    if(row.aboveNode){
     nodeStateMap = expandAboveNode(row.aboveNode,gridRef);}
    setTimeout(() => {
    let updatedcurrentSheetRows = gridRef.current.api.getModel().rowsToDisplay;
     const rowsToRemove = row.addedRows
    .map((row) => updatedcurrentSheetRows[row.index].data)
    gridRef.current.api.applyTransaction({
        remove: rowsToRemove
    });
    applyTransaction(gridRef,row.undoUpdatedRows)
    setTimeout(() => gridRef.current.api.redrawRows(), 200)
    setUndoStack([],true)
    setRedoStack([{ type: "row", action: "insertMultiple", rowsToAdd: rowsToRemove, index: row.addedRows[0].index, undoRows: row.addedRows, undoUpdatedRows:row.undoUpdatedRows, updatedRows:row.updatedRows ,aboveNode: row.aboveNode,belowNodeId : row.belowNodeId}],true)
    
})}


export const undoInsertRow = ({ row, gridRef, currentSheetRows, undoStack, redoStack, setRowData }) => {
    let newRedoVal = { ...undoStack[0] }
    let rowIndexToDelete = row.index
    let rowToDelete = currentSheetRows[rowIndexToDelete].data
    let selectedRows = gridRef.current.api.getSelectedRows()
    if (selectedRows.length === 0) selectedRows = [rowToDelete];
    let newRowData = [...currentSheetRows]
    let splicedData = newRowData[rowIndexToDelete]
    newRedoVal['rowData'] = splicedData.data
    let newUndoStack = undoStack
    newUndoStack = newUndoStack.slice(1)
    let newRedoStack = [newRedoVal, ...redoStack]
    setRowData({ undoStack: newUndoStack, redoStack: newRedoStack })
    gridRef.current.api.applyTransaction({
        remove: [currentSheetRows[rowIndexToDelete].data],
    });
    setTimeout(() => gridRef.current.api.redrawRows(), 0)
}

export const redoInsertRow = ({ row, gridRef, undoStack, redoStack, currentSheetRows, setRowData, insertRow, columnDefs }) => {
    let newUndoVal = { ...redoStack[0] }
    let body = { ...row.rowData }
    let id = uuidv4()
    if (body.l_id.includes('.')) {
        let temp = body.l_id.split('.')
        temp[temp.length - 1] = id
        body.l_id = temp.join('.')
    }
    else body.l_id = id
    body.id = id
    let apiBody = { ...body }
    if (columnDefs && columnDefs.length) {
        columnDefs.forEach((col) => {
            if (apiBody[col.field]) delete apiBody[col.field]
        })
    }
    delete apiBody['primaryCol']
    let newRowData = currentSheetRows.slice()
    insertRow( apiBody, (content) => {
        let rowData = { ...body, ...content }
        let newRedoStack = [...redoStack]
        newRedoStack = newRedoStack.slice(1)
        let newUndoStack = [newUndoVal, ...undoStack]
        setRowData({ undoStack: newUndoStack, redoStack: newRedoStack })
        gridRef.current.api.applyTransaction({
            add: [body],
            addIndex: row.index,
        });
        setTimeout(() => gridRef.current.api.redrawRows(), 0)
    })
}

export function updateLinkedColumns(row,updateMultipleColumns) {
    if (row.linkedColumnsBeforeColumnDelete) {
            updateMultipleColumns(row.linkedColumnsBeforeColumnDelete,);
    }
}
export function removeHeaderGroupProperties(column) {
    if (!column) return;

    // Delete the properties from the current column
    delete column.headerGroupComponentParams;
    delete column.headerGroupComponent;

    // Recursively handle children if they exist
    if (column.children && Array.isArray(column.children)) {
        column.children.forEach((child) => removeHeaderGroupProperties(child));
    }
}

export const undoColumnDelete = async ({ row, currentSheetColumnDefs, autoColumnGroupDefs, undoStack, setUndoStack, redoStack, setRedoStack, addColumnToIndex, setColumnDefs, gridRef, updateMultipleColumns }) => {
    let newColDefs = row.columnsForUndo
    await setColumnDefs({ colDefs: [], autoColumnGroupDefs })
    const updatedColumnDefs = [newColDefs[0], autoColumnGroupDefs || row.autoColumnGroupDefs, ...newColDefs.slice(1)]
    let columnsToInsert = [], leafColumns
    let rowsToUpdate = row.previousRows
    if (rowsToUpdate?.length) {
        let data = gridRef.current.api.applyTransaction({ update: rowsToUpdate });
        setTimeout(() => {

            gridRef.current.api.redrawRows();
            //  gridRef.current.api.ensureColumnVisible(leafColumns?leafColumns[0].colId:columnsToInsert[0].colId);
        }, 50)
    }
    if (row.isGroupDeleted) {
        let groupColumn = row.columnsToDeleteArray[0]
        leafColumns = row.columnsToDeleteArray.slice(1)
        updateLinkedColumns(row, updateMultipleColumns);
        if (groupColumn) {
            removeHeaderGroupProperties(groupColumn);
        }
        let groupWithoutChildren = JSON.parse(JSON.stringify(groupColumn));
        delete groupWithoutChildren.children;
        columnsToInsert = [groupWithoutChildren, ...leafColumns]
        let updatedColumnDefsForOuterLayer = newColDefs
        let insertIndex = row.index[0] + 1
        addColumnToIndex(insertIndex, columnsToInsert, '', updatedColumnDefsForOuterLayer)
    }
    else {  // Check if multiple columns were deleted and need to be restored
        if (Array.isArray(row.columnsToDeleteArray)) {
            columnsToInsert = row.columnsToDeleteArray
            addColumnToIndex(row.index[0] + 1, row.columnsToDeleteArray, '', updatedColumnDefs);
            row.columnsToDeleteArray.forEach((col, index) => {
                if (col?.linkedColumns) {
                    updateLinkedColumns(row, updateMultipleColumns);
                }
            });
        }
    }
    await setColumnDefs({ colDefs: newColDefs, autoColumnGroupDefs })
    setRedoStack(undoStack)
    setTimeout(() => {
        gridRef.current.api.ensureColumnVisible(leafColumns ? leafColumns[0].colId : columnsToInsert[0].colId);
    }, 1000)
}

export const redoColumnDelete = async ({ row, currentSheetColumnDefs, autoColumnGroupDefs, undoStack, setUndoStack, redoStack, setRedoStack, deleteColumn, setColumnDefs, gridRef, updateColumnWithId }) => {
    let columnsForRedo = row.columnsForRedo
    row.columnsToDeleteArray.forEach((column) => {
        if (column.linkedColumns) {
            let { columns } = removeLinkedColumns(columnsForRedo, column.linkedColumns, updateColumnWithId, gridRef);
            columnsForRedo = columns
        }
    })
    deleteColumn(row.columnsToDeleteArray.map((column)=>{return {colDef:column}}),columnsForRedo )
    setColumnDefs({ colDefs: columnsForRedo, autoColumnGroupDefs: row.autoColumnGroupDefs})
    setUndoStack(redoStack)
    let rowsToUpdate = row.cellRows
    if (rowsToUpdate?.length) {
        setTimeout(() => {
            gridRef.current.api.applyTransaction({ update: rowsToUpdate });
            gridRef.current.api.redrawRows();},0)
    }
}

export const bunchAndPlaceCalls = (cellValueCallbackArray, addMutipleRows, placeMultipleCallsForCellEdit, cellValueChanged, sheetType, selectedCellAfterRefresh) => {
    let copycellValueCallbackArray = { ...cellValueCallbackArray.current }
    cellValueCallbackArray.current = { calls: [], indentCalls: [], addMultiRows: false }
    let formattingCalls = copycellValueCallbackArray.calls
    let addMultiRows = copycellValueCallbackArray.addMultiRows
    let indentCalls = copycellValueCallbackArray.indentCalls
    if (addMultiRows) {
        setTimeout(() => {
            addMutipleRows(addMultiRows.count, addMultiRows.id)
        }, 5000)
    }
    if (formattingCalls && formattingCalls.length && sheetType == 'default') placeMultipleCallsForCellEdit(formattingCalls)
    else if (sheetType === 'jira') cellValueChanged(formattingCalls[formattingCalls.length - 1])
    if (indentCalls && indentCalls.length) {
        let finalIndentCalls = [], rowObj = {}
        indentCalls.reverse().forEach((row) => {
            if (!rowObj[row.sheetrowid]) { finalIndentCalls.push(row); rowObj[row.sheetrowid] = row }
        })
        placeMultipleCallsForCellEdit(indentCalls, selectedCellAfterRefresh)
    }
}

export const redoTransactionChanges = ({ undoStack, redoStack, gridRef, row, setSelectedCellHelper, setUndoStack, setRedoStack,operationInProcess,setOperationInProcess}) => {
    if(operationInProcess)return
    setOperationInProcess(true)
    setUndoStack([{ type: "row", action: "transaction", previousRows: row.previousRows, index: row.index, cellRows: row.cellRows,dontSelectCell: row.dontSelectCell}],true)
    gridRef.current.api.applyTransaction({
        update: row.cellRows,
        addIndex: row.index
    });
    setTimeout(() => {
        let focusedCell = gridRef.current.api.getFocusedCell();
            gridRef.current.api.redrawRows();
        if(row.dontSelectCell!==true){
            gridRef.current.api.clearRangeSelection()
            setTimeout(() => {
                gridRef.current.api.setFocusedCell(row.index, 'ag-Grid-AutoColumn', null);
                gridRef.current.api.addCellRange({ rowStartIndex: row.index, rowEndIndex: row.index, columnStart: 'ag-Grid-AutoColumn', columnEnd: 'ag-Grid-AutoColumn' })
            }, 1000)
        }
        
    }, 0)
    setTimeout(()=>{setOperationInProcess(false)},2200)
    setRedoStack([],true)
}

export const redoWrapChanges = async ({ undoStack, redoStack, row, gridRef, setRedoStack, setUndoStack }) => {
    setUndoStack({ type: 'row', action: 'wrap', previousRows: row.cellRows, cellRows: row.previousRows, index: row.index },true)
    gridRef.current.api.applyTransaction({
        remove: row.cellRows,
    });
    gridRef.current.api.applyTransaction({
        add: row.previousRows,
        addIndex: row.index
    });
    setTimeout(() => { gridRef.current.api.redrawRows() }, 0)
    setRedoStack([],true)
}

export const redoInsertMultiple = ({ currentSheetRows, undoStack, redoStack, gridRef, row, setUndoStack, setRedoStack, setRowData, columnDefs }) => {
    setUndoStack([{ type: "row", action: "insertMultiple", addedRows: row.undoRows ,allRowsAdded:row.rowsToAdd, undoUpdatedRows:row.undoUpdatedRows,updatedRows:row.updatedRows, aboveNode: row.aboveNode,belowNodeId:row.belowNodeId }],true)
    let nodeStateMap = new Map();
    if(row.aboveNode){
        nodeStateMap = expandAboveNode(row.aboveNode,gridRef);}
        setTimeout(() => {
             gridRef.current.api.applyTransaction({
        add: row.rowsToAdd,
        addIndex: row.index
    });
    applyTransaction(gridRef,row.updatedRows)
    setTimeout(() => gridRef.current.api.redrawRows(), 200)
    setRedoStack([],true)
    if(row.aboveNode) collapseAboveNode(row.aboveNode,gridRef,nodeStateMap);
        }, 50);
   

}

let debounceTimeout;
export const undoExpandChanges = ({ undoStack, redoStack, gridRef, row, setUndoStack, setRedoStack }) => {
    if (!gridRef.current || !gridRef.current.api) {
        console.error('Grid API is not available.');
        return;
    }
    // Get the current state of the row node
    const rowNode = gridRef.current.api.getRowNode(row.node.id);
    if (!rowNode) {
        console.error('Row node not found.');
        return;
    }
    // Determine the current expanded state
    const isExpanded = rowNode.expanded;
    // Perform the undo action by toggling the expanded state
    gridRef.current.api.setRowNodeExpanded(rowNode, !isExpanded);
    // Clear the undo stack and push the action to the redo stack
    setUndoStack([],true);
    const redoAction = {
        type: 'row',
        action: 'expand',
        node: row.node,
        expanded: !isExpanded,  // Store the new state for redo
        isFromUndo: true
    };
    setRedoStack([redoAction],true);
    //Custom debounce implementation
    if (debounceTimeout) {
        clearTimeout(debounceTimeout);
    }
    debounceTimeout = setTimeout(() => {
        if (gridRef.current && gridRef.current.api) {
            gridRef.current.api.redrawRows();
        }
    }, 100);
};

    export const redoExpandChanges = ({ undoStack, redoStack, gridRef, row, setUndoStack, setRedoStack }) => {
    gridRef.current.api.setRowNodeExpanded(row.node, !row.expanded);
    // const updatedUndoStack = [...undoStack, { type: 'row', action: 'expand', node: row.node, expanded: !row.expanded,isFromUndo:true }];
    setUndoStack([{ type: 'row', action: 'expand', node: row.node, expanded: !row.expanded,isFromUndo:true }],true);
    setRedoStack([],true);
    };

   export const prepareRedoStack = (undoStack, colDefinitionsForRedo, data) => {
        return undoStack.map(item => ({
            ...item,
            undoStackData: data,
            colDef: colDefinitionsForRedo,
        }));
    };
    
   export const generateUpdatedRows = (data, gridRef, updateFn) => {
        return data.reduce((acc, item) => {
            const { rowIndex, id } = item;
            if (rowIndex === undefined) return acc;
    
            const rowNode = gridRef.current.api.getRowNode(id);
            if (rowNode) {
                const rowData = { ...rowNode.data };
                updateFn(rowData, item);
                acc.push(rowData);
            } else {
                console.warn(`Row at index ${rowIndex} not found.`);
            }
            return acc;
        }, []);
    };
    
    export const applyGridUpdates = (gridRef, updatedRows) => {
        gridRef.current.api.showLoadingOverlay();
        setTimeout(() => {
            if (updatedRows.length) {
                gridRef.current.api.applyTransaction({ update: updatedRows });
                gridRef.current.api.refreshCells({ force: true });
            } else {
                console.log("No rows to update.");
            }
            gridRef.current.api.hideOverlay();
        }, 100);
    };
    
export const handleSelectedRowIndex = ({setSelectRowPopup,setSelectedRowIndex,selectedRowIndex,gridRef}) => {
    let firstColField = null;
    let rowIndex = rowIndex = parseInt(selectedRowIndex)
    const firstColumnId = gridRef?.current?.api?.getColumnState()[0]?.colId;
    firstColField = firstColumnId?.toString()
    gridRef.current.api.setFocusedCell(rowIndex - 1, firstColField, true);    
    gridRef.current.api.clearRangeSelection()
    gridRef.current.api.addCellRange({ rowStartIndex: rowIndex - 1, rowEndIndex: rowIndex - 1, columnStart: firstColField, columnEnd: firstColField });
    const rowNode = gridRef.current.api.getDisplayedRowAtIndex(rowIndex - 1)
    gridRef.current.api.ensureIndexVisible(rowIndex - 1, 'middle');
    gridRef.current.api.ensureColumnVisible(firstColField);
    if (rowNode) {
        const selectedNode = [rowNode];
        setTimeout(() => {
            gridRef.current.api.setNodesSelected({ nodes: selectedNode, newValue: true });
        }, 300);
    }    
        setSelectRowPopup(false);
        setSelectedRowIndex('');
}
export const undoTimeSeriesColumnUpdate = ({
    autoColumnGroupDefs,
    setColumnDefs,
    currentSheetColumnDefs,
    oldColDefs,
    undoStack,
    newColDefs,
    updatedColumnDefs,
    data,
    setRedoStack,
    gridRef,
    editColumnIds,
    updateMultipleColumns,
    previousColDef,
    updatedRedoStack
}) => {
    const updatesByRow = data.reduce((acc, { rowIndex, originalValue, id, columnId }) => {
        if (rowIndex === undefined) return acc;
        if (!acc[id]) acc[id] = { rowIndex, id, updates: {} };
        acc[id].updates[columnId] = originalValue;
        return acc;
    }, {});

    const finalUpdatedRows = Object.values(updatesByRow).reduce((acc, { id, updates }) => {
        const rowNode = gridRef.current.api.getRowNode(id);
        if (rowNode) {
            const rowData = { ...rowNode.data };
            Object.entries(updates).forEach(([colId, value]) => {
                rowData[colId] = value;
                if (rowData[colId + '_es']) {
                    rowData[colId + '_es'].value = value;
                }
            });
            acc.push(rowData);
        } else {
            console.warn(`Row with id ${id} not found.`);
        }
        return acc;
    }, []);

    gridRef.current.api.showLoadingOverlay();

    setTimeout(() => {
        setColumnDefs({ colDefs: previousColDef });
        updateMultipleColumns(oldColDefs, makeColumnArrayForDB(autoColumnGroupDefs, previousColDef));

        if (finalUpdatedRows.length) {
            gridRef.current.api.applyTransaction({ update: finalUpdatedRows });
            gridRef.current.api.refreshCells({ force: true });
        } else {
            console.log("No rows to update.");
        }

        setRedoStack(updatedRedoStack, true);
        gridRef.current.api.hideOverlay();
    }, 100);
};

export const undoColumnUpdate = ({
    currentSheetColumnDefs,
    undoStack,
    gridRef,
    setColumnDefs,
    setUndoStack,
    setRedoStack,
    redoStack,
    updateColumnWithId,
    updateMultipleColumns
}) => {
    if (!undoStack?.length) return;

    const {
        undoStackData: data,
        colDef: columnDefinations,
        columnId: colId,
        editColumnId: columnId,
        linkedColumnsBeforeColumnUpdate,
        editColumnIds,
        isTimeSeriesUpdate,
        newColDefs,
        updatedColumnDefs,
        previousColDef
    } = undoStack[0];

    const autoColumnGroupDefs = gridRef.current.api.getColumnDef("ag-Grid-AutoColumn");
    const updatedColDefs = [...columnDefinations];
    const currentColDef = [...currentSheetColumnDefs];
    const gridColumnId = columnId?.slice(0, -3)?.trim();

    let colDefinitionsForRedo = isTimeSeriesUpdate
        ? deepCopy(updatedColumnDefs)
        : deepCopy(currentColDef, ['headerGroupComponent', 'headerGroupComponentParams']);
    
    const updatedRedoStack = prepareRedoStack(undoStack, colDefinitionsForRedo, data);

    if (isTimeSeriesUpdate) {
        undoTimeSeriesColumnUpdate({
            autoColumnGroupDefs,
            setColumnDefs,
            currentSheetColumnDefs,
            oldColDefs: columnDefinations,
            undoStack,
            newColDefs,
            updatedColumnDefs,
            data,
            setRedoStack,
            gridRef,
            editColumnIds,
            updateMultipleColumns,
            previousColDef,
            updatedRedoStack
        });
    } else {
        if (currentSheetColumnDefs[0].colId !== "#") {
            [currentSheetColumnDefs[0], currentSheetColumnDefs[1]] = [currentSheetColumnDefs[1], currentSheetColumnDefs[0]];
        }

        setRedoStack(updatedRedoStack, true);

        const updatedRows = generateUpdatedRows(data, gridRef, (rowData, { originalValue }) => {
            rowData[gridColumnId + '_es'].value = originalValue;
            rowData[gridColumnId] = originalValue;
        });

        const { column, parent, index } = findColumnToUpdate(updatedColDefs, colId);
        if (index === -1) return;

        if (parent) {
            parent.children[index] = column;
        } else {
            updatedColDefs[index] = column;
        }

        let updatedLinkedeColumns = [];
        if (linkedColumnsBeforeColumnUpdate) {
            linkedColumnsBeforeColumnUpdate.forEach(linkedColumn => {
                const columnIndex = updatedColDefs.findIndex(col => col.colId === linkedColumn.colId);
                if (columnIndex !== -1) {
                    updatedLinkedeColumns.push(JSON.parse(JSON.stringify(updatedColDefs[columnIndex])));
                }
            });
            updateMultipleColumns(updatedLinkedeColumns);
        }

        setColumnDefs({ colDefs: updatedColDefs });
        updateColumnWithId(column, makeColumnArrayForDB(autoColumnGroupDefs, updatedColDefs));

        applyGridUpdates(gridRef, updatedRows);
    }

    setUndoStack([], true);
};

export const findColumnToUpdate = (columns, targetColId) => {
    for (let i = 0; i < columns.length; i++) {
        const column = columns[i];

        if (column.colId === targetColId) return { column, parent: null, index: i };

        if (column.children) {
            for (let j = 0; j < column.children.length; j++) {
                if (column.children[j].colId === targetColId) {
                    return { column: column.children[j], parent: column, index: j };
                }
            }
        }
    }
    return { column: null, parent: null, index: -1 };
};

export const redoTimeSeriesColumnUpdate = ({
    autoColumnGroupDefs,
    redoStack,
    setUndoStack,
    setColumnDefs,
    updatedColumnDefs,
    newColDefs,
    data,
    setRedoStack,
    gridRef,
    editColumnIds,
    updateMultipleColumns
}) => {
    const colDefinitionsForUndo = deepCopy(updatedColumnDefs);
    const updatedUndoStack = buildUndoStack({ redoStack, colDef: colDefinitionsForUndo, data });

    const finalUpdatedRows = prepareUpdatedRows({ data, gridRef });

    applyGridChanges({
        gridRef,
        updatedColDefs: newColDefs,
        updatedRows: finalUpdatedRows,
        updatedUndoStack,
        updateColumnFn: updateMultipleColumns,
        columnDataForDB: makeColumnArrayForDB(autoColumnGroupDefs, newColDefs),
        setColumnDefs,
        setUndoStack,
        setRedoStack
    });
};

export const redoColumnUpdate = ({
    currentSheetColumnDefs,
    redoStack,
    undoStack,
    gridRef,
    setColumnDefs,
    setRedoStack,
    setUndoStack,
    updateColumnWithId,
    updateMultipleColumns
}) => {
    if (!redoStack?.length) return;

    const {
        redoStackData: data,
        colDef: columnDefinations,
        columnId: colId,
        editColumnId: columnId,
        linkedColumnsBeforeColumnUpdate,
        editColumnIds,
        isTimeSeriesUpdate,
        newColDefs,
        updatedColumnDefs
    } = redoStack[0];

    const autoColumnGroupDefs = getAutoColumnGroupDefs(gridRef);

    if (isTimeSeriesUpdate) {
        return redoTimeSeriesColumnUpdate({
            autoColumnGroupDefs,
            redoStack,
            setUndoStack,
            setColumnDefs,
            updatedColumnDefs,
            newColDefs,
            data,
            setRedoStack,
            gridRef,
            editColumnIds,
            updateMultipleColumns
        });
    }

    const currentColDef = [...currentSheetColumnDefs];
    const gridColumnId = columnId?.slice(0, -3)?.trim();
    const colDefinitionsForUndo = deepCopy(currentColDef, ['headerGroupComponent', 'headerGroupComponentParams']);
    const updatedUndoStack = buildUndoStack({ redoStack, colDef: colDefinitionsForUndo, data });

    const updatedColDefs = [...(columnDefinations || [])];
    const { column, parent, index } = findColumnToUpdate(updatedColDefs, colId);
    if (index === -1) return;

    if (parent) parent.children[index] = column;
    else updatedColDefs[index] = column;

    if (linkedColumnsBeforeColumnUpdate) {
        const linkedColumnforupdation = linkedColumnsBeforeColumnUpdate.map(linkedColumn => {
            const columnIndex = updatedColDefs.findIndex(col => col.colId === linkedColumn.colId);
            return columnIndex !== -1 ? JSON.parse(JSON.stringify(updatedColDefs[columnIndex])) : null;
        }).filter(Boolean);
        updateMultipleColumns(linkedColumnforupdation);
    }

    const updatedRows = data.reduce((acc, { rowIndex, rowValue, columnId, id }) => {
        if (rowIndex === undefined) return acc;
        const rowNode = gridRef.current.api.getRowNode(id);
        if (rowNode) {
            const rowData = { ...rowNode.data };
            if (rowData[gridColumnId]) {
                rowData[gridColumnId + '_es'].value = rowValue;
                rowData[gridColumnId] = rowValue;
                acc.push(rowData);
            }
        } else {
            console.warn(`Row at index ${rowIndex} not found.`);
        }
        return acc;
    }, []);

    applyGridChanges({
        gridRef,
        updatedColDefs,
        updatedRows,
        updatedUndoStack,
        updateColumnFn: (colDefs, dbData) => updateColumnWithId(column, dbData),
        columnDataForDB: makeColumnArrayForDB(autoColumnGroupDefs, updatedColDefs),
        setColumnDefs,
        setUndoStack,
        setRedoStack
    });
};

export const applyGridChanges = ({
    gridRef,
    updatedColDefs,
    updatedRows,
    updatedUndoStack,
    updateColumnFn,
    columnDataForDB,
    setColumnDefs,
    setUndoStack,
    setRedoStack
}) => {
    gridRef.current.api.showLoadingOverlay();

    setTimeout(() => {
        setColumnDefs({ colDefs: updatedColDefs });
        updateColumnFn(updatedColDefs, columnDataForDB);

        if (updatedRows.length) {
            gridRef.current.api.applyTransaction({ update: updatedRows });
            gridRef.current.api.refreshCells({ force: true });
        } else {
            console.log("No rows to update.");
        }

        setUndoStack(updatedUndoStack, true);
        setRedoStack([], true);

        setUndoStack(updatedUndoStack);
        setRedoStack([]);

        gridRef.current.api.hideOverlay();
    }, 50);
};

export const buildUndoStack = ({ redoStack, colDef, data }) =>
    redoStack.map(item => ({
        ...redoStack[0],
        redoStackData: data,
        colDef: colDef,
    }));

export const prepareUpdatedRows = ({ data, gridRef, gridColumnId = null }) => {
    const updatesByRow = data.reduce((acc, { rowIndex, rowValue, id, columnId }) => {
        if (rowIndex === undefined) return acc;
        if (!acc[id]) acc[id] = { rowIndex, id, updates: {} };
        acc[id].updates[columnId] = rowValue;
        return acc;
    }, {});

    return Object.values(updatesByRow).reduce((acc, { id, updates }) => {
        const rowNode = gridRef.current.api.getRowNode(id);
        if (rowNode) {
            const rowData = { ...rowNode.data };
            Object.entries(updates).forEach(([colId, value]) => {
                rowData[colId] = value;
                if (rowData[colId + '_es']) {
                    rowData[colId + '_es'].value = value;
                }
            });
            acc.push(rowData);
        } else {
            console.warn(`Row with id ${id} not found.`);
        }
        return acc;
    }, []);
};

export const getAutoColumnGroupDefs = (gridRef) => gridRef.current.api.getColumnDef("ag-Grid-AutoColumn");
